import React, { useEffect, useState, useRef } from "react";
import axios from "../../api/axios";
import {
  Row,
  Col,
  Button,
  Form,
  Table,
  Modal,
  Badge,
  Spinner,
  Pagination,
  InputGroup,
  FormControl,
  FormSelect,
  FormLabel,
  Alert,
  Dropdown,
  Card,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import Header from "../../layouts/Header";
import { ArrowLeft, Calculator, CurrencyDollar, FileEarmarkExcel, FileEarmarkSpreadsheet, Receipt, Tag } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import OutletSelect from "../../components/OutletSelect";

const OrdersReport = () => {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      borderRadius: "6px",
      minWidth: "200px",
      borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
      "&:hover": {
        borderColor: state.isFocused ? "#80bdff" : "#ced4da",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d",
    }),
  };

  const { userId } = useSelector((state) => state.login);
  const { access } = useSelector((state) => state.login);
  const { email } = useSelector((state) => state.login);
  const [reportAccess, setReportAccess] = useState([]);

  console.log("User Id :", userId);
  console.log("Email :", email);

  console.log("Access :", access);

  useEffect(() => {
    if (Array.isArray(access)) {
      const filteredAccess = access?.filter((perm) =>
        perm?.startsWith("OrdersReport:")
      );
      setReportAccess(filteredAccess);
    }
  }, [access]);

  console.log("Report Access :", reportAccess);

  const getItemTotal = (item) => {
    const basePrice =
      selectedOrder?.order?.coupon?.isMrpDiscount && item.discount > 0
        ? item.mrpRate
        : item.rate;

    const addonsTotal =
      item?.addons?.reduce((sum, addon) => sum + addon.price, 0) || 0;

    return (basePrice + addonsTotal) * item.quantity;
  };


  const accessToken = localStorage.getItem("authToken");
  const [ordersData, setOrdersData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [selectedOutletName, setSelectedOutletName] = useState('');
  const [outlets, setOutlets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [viewDetailsModal, setViewDetailsModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [subBtnLoading, setSubBtnLoading] = useState(false);
  const [printBtnLoading, setPrintBtnLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState("");
  const [totalRecords, setTotalRecords] = useState("");
  const [ordersGrandTotal, setOrdersGrandTotal] = useState("");
  const [ordersTotalTaxAmt, setOrdersTotalTaxAmt] = useState("");
  const [ordersTotalDiscountAmt, setOrdersTotalDiscountAmt] = useState("");
  const [ordersTotalTaxable, setOrdersTotalTaxable] = useState("");
  const [recordsPerPage, setRecordsPerPage] = useState(25);
  const [errorMsg, setErrorMsg] = useState("");
  const [clicked, setClicked] = useState(false);
  const [orderType, setOrderType] = useState('');
  const [orderStatus, setOrderStatus] = useState('');
  const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
  const [currentDate, setCurrentDate] = useState(null);

  //Cancel Order States 
  const [cancelBtnLoading, setCancelBtnLoading] = useState(false);
  const [openCancelOrderModal, setOpenCancelOrderModal] = useState(false);
  const [cancelOrderData, setCancelOrderData] = useState({});
  const [refundType, setRefundType] = useState('');
  const [isStockRefund, setIsStockRefund] = useState(false);
  const [reason, setReason] = useState('');
  const [selectedOrderId, setSelectedOrderId] = useState('');
  const [usersList, setUsersList] = useState([]);
  const [selectedAdminUser, setSelectedAdminUser] = useState('');
  const lastPage = Math.ceil(totalRecords / recordsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }

    getOrderData(startDate, endDate, selectedOutlet?.value || "", page, recordsPerPage, searchText, orderType, orderStatus);
  };

  const handleSearchOrders = () => {
    const trimmedSearchText = searchText.trim().toLowerCase();
    if (trimmedSearchText) {
      const filtered = ordersData.filter((order) => {
        const orderNo = order.order?.order_no;
        const orderSequence = order.order?.order_sequence;
        const userName = order.order?.user?.name;
        const orderNoString = String(orderNo);
        const combinedSearchString =
          `${orderSequence}${orderNoString}`.toLowerCase();

        return (
          combinedSearchString.includes(trimmedSearchText) ||
          (typeof userName === "string" &&
            userName.toLowerCase().includes(trimmedSearchText))
        );
      });

      setFilteredData(filtered);
    } else {
      setFilteredData(ordersData);
    }
  };

  const handleSubmit = async () => {
    setSubBtnLoading(true);
    setClicked(true);
    setCurrentPage(1);

    const adjustedStartDate = new Date(startDate?.setHours(23, 59, 59, 999));
    const adjustedEndDate = new Date(endDate?.setHours(23, 59, 59, 999));

    await getOrderData(
      adjustedStartDate,
      adjustedEndDate,
      selectedOutlet?.value || "",
      1,
      recordsPerPage,
      searchText,
      orderType,
      orderStatus
    );
    setSubBtnLoading(false);
  };

  const handleDownloadExcel = async () => {
    setDownloadBtnLoading(true);
    const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
    const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
    getOrderData(adjustedStartDate, adjustedEndDate, selectedOutlet?.value || "", currentPage, recordsPerPage, searchText, orderType, orderStatus, true);
  };

  const getOrderData = async (
    startDate,
    endDate,
    outlet,
    page,
    limit,
    search,
    orderT,
    orderS,
    download
  ) => {
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "content-type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      };

      let url = `order/getOrdersForAdmin`;

      if (startDate && endDate) {
        url += `?startDate=${startDate.toISOString().split("T")[0]}&endDate=${endDate.toISOString().split("T")[0]}`;
      } else {
        url += `?`;
      }

      if (outlet && outlet !== '') {
        url += `${url.includes('?') ? '&' : '?'}outlet=${outlet}`;
      }

      if (search && search !== "") {
        url += `${url.includes('?') ? '&' : '?'}search=${search}`;
      } else {
        url += `${url.includes('?') ? '&' : '?'}limit=${limit}&page=${page}`;
      }

      if (orderT) {
        url += `${url.includes('?') ? '&' : '?'}orderType=${orderT}`;
      }

      if (orderS) {
        url += `${url.includes('?') ? '&' : '?'}orderStatus=${orderS}`;
      }

      if (download) {
        url += `${url.includes('?') ? '&' : '?'}isDownload=${download}`;
      }

      const response = await axios.get(url, {
        headers,
        responseType: download ? 'blob' : 'json'
      });

      if (download) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${selectedOutlet?.label || 'All Outlets'} Orders Report (${endDate.toISOString().split("T")[0]}).xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        toast.success('Excel file downloaded successfully!', {
          position: "top-right",
          autoClose: 3000,
          theme: "light"
        });
      } else {
        const ordersData = response?.data?.data?.totalOrdersData || [];
        if (ordersData.length > 0) {
          setOrdersData(ordersData);
          setFilteredData(ordersData);
          setTotalPages(response?.data?.data?.paginationData?.totalPages || 0);
          setTotalRecords(response?.data?.data?.totalOrdersCount || 0);
          setOrdersGrandTotal(response?.data?.data?.ordersGrandTotal || 0);
          setOrdersTotalDiscountAmt(response?.data?.data?.ordersTotalDiscount || 0);
          setOrdersTotalTaxAmt(response?.data?.data?.ordersTotalTaxAmount || 0);
          setOrdersTotalTaxable(response?.data?.data?.ordersTotalTaxable || 0);

          toast.success("Data fetched successfully", {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
          });
        } else {
          toast.info("No records found.", {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
          });
          setFilteredData([]);
        }
      }

    } catch (error) {
      console.error("Error fetching orders data:", error);
      setFilteredData([]);
      if (error?.response) {
        let errorMessage = "";
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        } else {
          errorMessage = "Something went wrong. Please try again.";
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setLoading(false);
      setDownloadBtnLoading(false);
    }
  };

  const viewOrderDetails = (order) => {
    console.log("View Modal :", order);

    setSelectedOrder(order);
    setViewDetailsModal(true);
  };

  const closeModal = () => {
    setViewDetailsModal(false);
    setSelectedOrder(null);
  };

  const getAllOrderDataForReport = async (startDate, endDate, outlet) => {
    try {
      setLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };

      let url = `order/getOrdersForAdmin?startDate=${startDate.toISOString().split("T")[0]
        }&endDate=${endDate.toISOString().split("T")[0]}&page=1&limit=10000`;

      if (outlet) {
        url += `&outlet=${outlet}`;
      }

      const response = await axios.get(url, { headers });
      setOrdersGrandTotal(response?.data?.data?.ordersGrandTotal);
      setOrdersTotalDiscountAmt(response?.data?.data?.ordersTotalDiscount);
      setOrdersTotalTaxAmt(response?.data?.data?.ordersTotalTaxAmount);
      setOrdersTotalTaxable(response?.data?.data?.ordersTotalTaxable);
      return response?.data?.data?.totalOrdersData || [];
    } catch (error) {
      console.error("Error fetching orders data for report:", error);
      setOrdersGrandTotal(0);
      setOrdersTotalDiscountAmt(0);
      setOrdersTotalTaxAmt(0);
      setOrdersTotalTaxable(0);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const calculateTotal = () => {
    let total = 0;

    selectedOrder?.orderItems?.forEach((item) => {
      let itemPrice = selectedOrder?.order?.coupon?.isMrpDiscount
        ? item.mrpRate
        : item.rate;
      let addonsTotal = item?.addons?.reduce(
        (sum, addon) => sum + addon?.price,
        0
      );
      total += (itemPrice + addonsTotal) * item?.quantity;
    });

    total += selectedOrder?.order?.platformFees || 0;
    total += selectedOrder?.order?.packingCharges || 0;
    total += selectedOrder?.order?.deliveryCharges || 0;

    return total.toFixed(2);
  };

  const handlePrintReport = async () => {
    setPrintBtnLoading(true);
    const allOrdersData = await getAllOrderDataForReport(
      startDate,
      endDate,
      selectedOutlet?.value || ""
    );
    setPrintBtnLoading(false);

    const grandTotal = allOrdersData
      ?.reduce((total, orderInfo) => {
        return orderInfo?.order?.orderStatus !== "CANCELLED"
          ? total + (orderInfo?.order?.grandTotal || 0)
          : total;
      }, 0)
      .toFixed(2);

    const formatDate = (date) => {
      return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    };

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    const tableContent = `
      <table style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Sr.No</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Order No</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left; width: 120px">User Details</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Order Status</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Date & Time</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Coupon Status</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Coupon Code</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Total</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Tax Amt</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Tot Dis</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left; width: 70px">Overall Total</th>
          </tr>
        </thead>
        <tbody>
          ${allOrdersData.length > 0
        ? allOrdersData
          .map((orderInfo, index) => {
            const userMobile = orderInfo?.order?.user?.mobile;
            const formattedMobile = userMobile?.includes("_deleted_")
              ? `${userMobile.split("_deleted_")[0]} [Deleted]`
              : userMobile;

            return `
                  <tr>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${index + 1
              }</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.order_sequence
              }${orderInfo?.order?.order_no}</td>
                    
                    <td style="border: 1px solid black; padding: 8px; font-size: 10px; word-break: break-word; width: 210px">
                      ${orderInfo?.order?.outletUser
                ? `<span>${orderInfo?.order?.outletUser?.name} [Complimentary Order]</span><br />
                              <span>${orderInfo?.order?.outletUser?.mobile}</span>`
                : orderInfo?.order?.kioskUser
                  ? `<span>${orderInfo?.order?.kioskUser?.name} [Kiosk User]</span><br />
                              <span>${orderInfo?.order?.kioskUser?.phone}</span>`
                  : `<span>${orderInfo?.order?.user?.name}</span><br />
                              <span>${formattedMobile}</span>`
              }

                    </td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.orderStatus
              }</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px;">
                      <span>${new Date(
                orderInfo?.order?.createdAt
              ).toLocaleDateString("en-US", {
                day: "numeric",
                month: "numeric",
                year: "numeric",
              })}</span> <br />
                      <span>${new Date(
                orderInfo?.order?.createdAt
              ).toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })}</span>
                    </td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.coupon ? "Applied" : "Not Applied"
              }</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.coupon
                ? orderInfo?.order?.coupon?.couponCode
                : "-----"
              }</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.totalTaxable?.toFixed(
                2
              )}</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.totalTaxAmount?.toFixed(
                2
              )}</td>
                    <td style="border: 1px solid black; padding: 8px; font-size: 11px">${orderInfo?.order?.totalDiscount?.toFixed(
                2
              )}</td>
                    <td style="border: 1px solid black; padding: 8px; text-align: end; font-size: 13px; width: 150px">₹. ${orderInfo?.order?.grandTotal?.toFixed(
                2
              )}</td>
                  </tr>
                `;
          })
          .join("") +
        `
              <tr style="font-weight: semibold;">
                <td colspan="10" style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  Total (Excluding Tax)
                </td>
                <td style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  ₹ ${ordersTotalTaxable?.toFixed(2)}
                </td>
              </tr>
              <tr style="font-weight: semibold;">
                <td colspan="10" style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  Total Tax
                </td>
                <td style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  ₹ ${ordersTotalTaxAmt?.toFixed(2)}
                </td>
              </tr>
              <tr style="font-weight: semibold;">
                <td colspan="10" style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  Total Discount
                </td>
                <td style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">
                  ₹ ${ordersTotalDiscountAmt?.toFixed(2)}
                </td>
              </tr>
              <tr style="font-weight: bold;">
                  <td colspan="10" style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">Grand Total</td>
                  <td style="border: 1px solid black; padding: 8px; text-align: right; font-size: 12px">₹ ${ordersGrandTotal?.toFixed(
          2
        )}</td>
              </tr>`
        : `<tr>
                <td colspan="11" style="border: 1px solid black; padding: 8px; text-align: center;">No Orders Found</td>
              </tr>`
      }
        </tbody>
      </table>
    `;

    const win = window.open("", "", "width=900,height=600");
    win.document.write(`
      <html>
        <head>
          <title>Orders Report</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body onload="window.print();window.close()">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <h2>Orders Report</h2>
            <span>From [${formattedStartDate} to ${formattedEndDate}]</span>
          </div>
          <div>${tableContent}</div>
        </body>
      </html>
    `);
    win.document.close();
  };

  const handlePrintInvoice = (order) => {
    const win = window.open("", "", "width=820,height=700");

    const arrivalBadge = (() => {
      const status = order?.order?.orderArrivalStatus;
      if (status === "DELAYED") return `<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(220,53,69,0.1);color:#dc3545;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:600;">⏱ Delayed &nbsp;(+${order?.order?.delayedArrival} min)</span>`;
      if (status === "EARLY") return `<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(25,135,84,0.1);color:#198754;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:600;">⚡ Early &nbsp;(-${order?.order?.earlyArrival} min)</span>`;
      return `<span style="display:inline-flex;align-items:center;gap:6px;background:rgba(13,110,253,0.1);color:#0d6efd;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:600;">✓ On Time</span>`;
    })();

    const itemsRows = order.orderItems.map(item => `
    <tr>
      <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;">
        <div style="font-weight:600;color:#1a1a2e;font-size:13px;">${item.product.name}</div>
        ${item?.addons?.length > 0 ? `<div style="margin-top:4px;">${item.addons.map(a => `<span style="font-size:11px;color:#666;display:block;padding-left:10px;">+ ${a.selectedValue} <span style="color:#888;">(₹${a.price?.toFixed(2)})</span></span>`).join('')}</div>` : ''}
      </td>
      <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:center;color:#555;font-size:13px;">${item.quantity}</td>
      <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:right;color:#555;font-size:13px;">₹${item.rate?.toFixed(2)}</td>
      <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:right;font-weight:600;color:#1a1a2e;font-size:13px;">₹${(item.rate * item.quantity + (item?.addons?.reduce((s, a) => s + a.price, 0) || 0) * item.quantity).toFixed(2)}</td>
    </tr>
  `).join('');

    win.document.write(`<!DOCTYPE html>
  <html>
  <head>
    <title>Invoice #${order.order.order_sequence}${order.order.order_no}</title>
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
      * { margin:0; padding:0; box-sizing:border-box; }
      body { font-family:'DM Sans',sans-serif; background:#f5f5f0; color:#1a1a2e; }
      .page { max-width:720px; margin:30px auto; background:#fff; border-radius:16px; overflow:hidden; box-shadow:0 8px 40px rgba(0,0,0,0.10); }
      
      /* Header */
      .header { background:linear-gradient(135deg,#1a1a2e 0%,#16213e 60%,#0f3460 100%); padding:36px 40px 28px; position:relative; overflow:hidden; }
      .header::before { content:''; position:absolute; top:-40px; right:-40px; width:180px; height:180px; border-radius:50%; background:rgba(255,255,255,0.05); }
      .header::after  { content:''; position:absolute; bottom:-30px; right:60px; width:100px; height:100px; border-radius:50%; background:rgba(255,255,255,0.04); }
      .store-name { font-family:'Playfair Display',serif; font-size:26px; font-weight:700; color:#fff; letter-spacing:0.5px; }
      .store-sub  { font-size:12px; color:rgba(255,255,255,0.55); margin-top:4px; letter-spacing:1px; text-transform:uppercase; }
      .store-meta { font-size:11.5px; color:rgba(255,255,255,0.65); margin-top:14px; line-height:1.7; }
      .invoice-label { display:inline-block; background:rgba(255,255,255,0.12); border:1px solid rgba(255,255,255,0.2); color:#fff; font-size:11px; font-weight:600; letter-spacing:2px; text-transform:uppercase; padding:5px 14px; border-radius:20px; margin-top:16px; }
      
      /* Meta strip */
      .meta-strip { display:grid; grid-template-columns:repeat(3,1fr); gap:0; border-bottom:1px solid #f0f0f0; }
      .meta-cell  { padding:18px 22px; border-right:1px solid #f0f0f0; }
      .meta-cell:last-child { border-right:none; }
      .meta-label { font-size:10px; font-weight:600; color:#999; text-transform:uppercase; letter-spacing:1px; margin-bottom:5px; }
      .meta-value { font-size:13px; font-weight:600; color:#1a1a2e; }
      .meta-value.highlight { color:#0f3460; }
      
      /* Status pill */
      .status-pill { display:inline-flex; align-items:center; gap:5px; padding:3px 10px; border-radius:20px; font-size:11px; font-weight:700; letter-spacing:0.5px; }
      .status-COMPLETED,.status-DELIVERED { background:#e8f7ef; color:#198754; }
      .status-CONFIRMED { background:#e8f0fe; color:#4361ee; }
      .status-CANCELLED { background:#fce8e8; color:#dc3545; }
      .status-default   { background:#f0f0f0; color:#555; }
      
      /* Customer + Order info */
      .info-grid { display:grid; grid-template-columns:1fr 1fr; gap:0; border-bottom:1px solid #f0f0f0; }
      .info-box  { padding:20px 24px; }
      .info-box:first-child { border-right:1px solid #f0f0f0; }
      .info-box h4 { font-size:10px; font-weight:700; color:#aaa; text-transform:uppercase; letter-spacing:1.5px; margin-bottom:10px; }
      .info-box p  { font-size:13px; color:#333; line-height:1.7; }
      .info-box strong { color:#1a1a2e; }
      
      /* Items table */
      .items-section { padding:24px; }
      .section-title { font-family:'Playfair Display',serif; font-size:15px; font-weight:600; color:#1a1a2e; margin-bottom:14px; padding-bottom:10px; border-bottom:2px solid #1a1a2e; display:flex; justify-content:space-between; align-items:center; }
      table { width:100%; border-collapse:collapse; }
      thead tr { background:#f8f8f6; }
      thead th { padding:10px 12px; font-size:10px; font-weight:700; color:#888; text-transform:uppercase; letter-spacing:1px; text-align:left; }
      thead th:last-child, thead th:nth-child(3), thead th:nth-child(2) { text-align:right; }
      thead th:nth-child(2) { text-align:center; }
      
      /* Totals */
      .totals { border-top:2px solid #f0f0f0; margin-top:4px; }
      .total-row { display:flex; justify-content:space-between; padding:7px 12px; font-size:13px; color:#555; }
      .total-row.discount { color:#dc3545; }
      .total-row.tax      { color:#f59e0b; }
      .grand-total { background:linear-gradient(135deg,#1a1a2e,#0f3460); margin:16px 24px 24px; border-radius:12px; padding:18px 20px; display:flex; justify-content:space-between; align-items:center; }
      .grand-total span:first-child { font-size:13px; color:rgba(255,255,255,0.7); font-weight:500; letter-spacing:0.5px; }
      .grand-total span:last-child  { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:#fff; }
      
      /* Arrival */
      .arrival-section { margin:0 24px 20px; padding:14px 18px; background:#f8f8f6; border-radius:10px; display:flex; align-items:center; justify-content:space-between; }
      .arrival-label { font-size:11px; font-weight:700; color:#999; text-transform:uppercase; letter-spacing:1px; }
      
      /* Footer */
      .footer { background:#f8f8f6; padding:18px 24px; display:flex; justify-content:space-between; align-items:center; border-top:1px solid #eee; }
      .footer-left  { font-size:11px; color:#aaa; }
      .footer-right { font-size:11px; color:#aaa; text-align:right; }
      .thank-you { text-align:center; padding:20px; font-family:'Playfair Display',serif; font-size:15px; color:#1a1a2e; letter-spacing:0.5px; border-top:1px solid #f0f0f0; }
      
      @media print {
        body { background:#fff; }
        .page { box-shadow:none; margin:0; border-radius:0; }
      }
    </style>
  </head>
  <body onload="window.print();window.close()">
    <div class="page">
      
      <!-- Header -->
      <div class="header">
        <div class="store-name">${order?.orderStatusLogs[0]?.outlet?.name || 'XPANSE CAFE'}</div>
        <div class="store-sub">Premium Cafe & Restaurant</div>
        <div class="store-meta">
          ${order?.orderStatusLogs[0]?.outlet?.address || ''}<br/>
          GSTIN: ${order?.orderStatusLogs[0]?.outlet?.gstin || 'N/A'} &nbsp;|&nbsp; Tel: ${order?.orderStatusLogs[0]?.outlet?.phone || 'N/A'}
        </div>
        <div class="invoice-label">Tax Invoice</div>
      </div>

      <!-- Meta Strip -->
      <div class="meta-strip">
        <div class="meta-cell">
          <div class="meta-label">Invoice No</div>
          <div class="meta-value highlight">#${order?.order?.order_sequence}${order?.order?.order_no}</div>
        </div>
        <div class="meta-cell">
          <div class="meta-label">Date & Time</div>
          <div class="meta-value">${new Date(order?.order?.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
          <div style="font-size:11px;color:#888;margin-top:2px;">${new Date(order?.order?.createdAt).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</div>
        </div>
        <div class="meta-cell">
          <div class="meta-label">Order Status</div>
          <div style="margin-top:4px;">
            <span class="status-pill status-${order?.order?.orderStatus || 'default'}">${order?.order?.orderStatus || 'N/A'}</span>
          </div>
          <div style="font-size:11px;color:#888;margin-top:5px;">${order?.order?.paymentGatewayProvider || order?.order?.paymentMode || 'N/A'}</div>
        </div>
      </div>

      <!-- Customer + Order Info -->
      <div class="info-grid">
        <div class="info-box">
          <h4>Bill To</h4>
          <p>
            <strong>${order?.order?.outletUser?.name || order?.order?.kioskUser?.name || order?.order?.user?.name || 'Walk-in Customer'}</strong><br/>
            ${order?.order?.outletUser?.mobile || order?.order?.kioskUser?.phone || order?.order?.user?.mobile || 'N/A'}<br/>
            ${order?.order?.coupon ? `<span style="font-size:11px;background:#e8f7ef;color:#198754;padding:2px 8px;border-radius:4px;margin-top:4px;display:inline-block;">🏷 Coupon: ${order?.order?.coupon?.couponCode}</span>` : ''}
          </p>
        </div>
        <div class="info-box">
          <h4>Order Info</h4>
          <p>
            <strong>Type:</strong> ${order?.order?.ordersType || order?.order?.paymentMode || 'N/A'}<br/>
            <strong>Pickup:</strong> ${order?.order?.pickupOption || 'N/A'}<br/>
            <strong>Payment:</strong> ${order?.order?.paymentStatus || 'N/A'}
          </p>
        </div>
      </div>

      <!-- Items Table -->
      <div class="items-section">
        <div class="section-title">
          <span>Order Items</span>
          <span style="font-size:12px;font-weight:500;font-family:'DM Sans',sans-serif;color:#888;">${order.orderItems.length} item${order.orderItems.length !== 1 ? 's' : ''}</span>
        </div>
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th style="text-align:center;">Qty</th>
              <th style="text-align:right;">Unit Price</th>
              <th style="text-align:right;">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${itemsRows}
          </tbody>
        </table>

        <!-- Totals -->
        <div class="totals">
          ${order?.order?.platformFees ? `<div class="total-row"><span>Platform Fees</span><span>₹${Number(order.order.platformFees).toFixed(2)}</span></div>` : ''}
          ${order?.order?.packingCharges ? `<div class="total-row"><span>Packing Charges</span><span>₹${Number(order.order.packingCharges).toFixed(2)}</span></div>` : ''}
          ${order?.order?.deliveryCharges ? `<div class="total-row"><span>Delivery Charges</span><span>₹${Number(order.order.deliveryCharges).toFixed(2)}</span></div>` : ''}
          <div class="total-row"><span>Subtotal (Taxable)</span><span>₹${order?.order?.totalTaxable?.toFixed(2)}</span></div>
          <div class="total-row discount"><span>Discount</span><span>− ₹${order?.order?.totalDiscount?.toFixed(2)}</span></div>
          <div class="total-row tax"><span>Tax (${order.order.taxDetails?.length ? order.order.taxDetails.map(t => t.name + ' @' + t.rate + '%').join(', ') : 'Inclusive'})</span><span>+ ₹${order?.order?.totalTaxAmount?.toFixed(2)}</span></div>
        </div>
      </div>

      <!-- Grand Total -->
      <div class="grand-total">
        <span>GRAND TOTAL</span>
        <span>₹${order?.order?.grandTotal?.toFixed(2)}</span>
      </div>

      <!-- Arrival Status -->
      <div class="arrival-section">
        <span class="arrival-label">Arrival Status</span>
        ${arrivalBadge}
      </div>

      <!-- Thank You -->
      <div class="thank-you">Thank you for choosing ${order?.orderStatusLogs[0]?.outlet?.name || 'us'}! 🙏</div>

      <!-- Footer -->
      <div class="footer">
        <div class="footer-left">Terms & Conditions Apply<br/>This is a computer generated invoice</div>
        <div class="footer-right">Powered by Xpanse POS<br/>${order?.orderStatusLogs[0]?.outlet?.name || 'XPANSE CAFE'}</div>
      </div>

    </div>
  </body>
  </html>`);
    win.document.close();
  };

  const handleOpenCancelOrderModal = (orderData) => {
    setOpenCancelOrderModal(true);
    setCancelOrderData(orderData);
    setSelectedOrderId(orderData?.order?._id);
  }

  const handleCancelNormalOrder = async (e) => {
    e.preventDefault();
    setCancelBtnLoading(true);
    try {
      console.log("Normal Order Cancel Api");
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      let reqBody = {
        refundType: refundType,
        reason: reason,
        isStockRefund: isStockRefund,
        _id: selectedOrderId,
        approval: selectedAdminUser,
        userId: userId
      }
      console.log("Reeqqq Body :", reqBody);
      const response = await axios.put('order/cancel/admin/new', reqBody, { headers });
      console.log("Response :", response);
      getOrderData(
        startDate,
        endDate,
        selectedOutlet?.value || "",
        currentPage,
        recordsPerPage,
        searchText,
        orderType,
        orderStatus
      );
      toast.success(response?.data?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } catch (error) {
      console.log("Error in Normal Order :", error);
      if (error?.response) {
        let errorMessage = '';
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
        } else if (error.response?.status === 403) {
          errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
        }
        else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      }
    } finally {
      setCancelBtnLoading(false);
    }
  }

  const handleCancelSubsOrder = async (e) => {
    e.preventDefault();
    setCancelBtnLoading(true);
    try {
      console.log("Subscription Order Cancel Api");

      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      let reqBody = {
        refundType: refundType,
        reason: reason,
        approval: selectedAdminUser,
        isStockRefund: isStockRefund,
        _id: selectedOrderId
      }
      console.log("Reeqqq Body :", reqBody);
      const response = await axios.put('order/cancelOrderAdmin', reqBody, { headers });
      console.log("Response :", response);
      getOrderData(
        startDate,
        endDate,
        selectedOutlet?.value || "",
        currentPage,
        recordsPerPage,
        searchText,
        orderType,
        orderStatus
      );
      toast.success(response?.data?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } catch (error) {
      console.log("Error In Subscription :", error);
      if (error?.response) {
        let errorMessage = '';
        if (error.response?.status === 406) {
          errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
        }
        else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error
        }

        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setCancelBtnLoading(false);
    }
  }

  const handleCloseCancelOrderModal = () => {
    setOpenCancelOrderModal(false);
    setRefundType('');
    setIsStockRefund();
    setSelectedOrderId('');
    setReason('');
  }

  useEffect(() => {
    const now = new Date();
    const currentD = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const start = new Date(currentD.setHours(23, 59, 59, 999));
    setCurrentDate(start);
    console.log("Current date :", start);

  }, [])

  useEffect(() => {
    const fetchOrderData = () => {
      if (searchText === "") {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate()
        );
        const start = new Date(currentDate.setHours(23, 59, 59, 999));
        const end = new Date(now.setHours(23, 59, 59, 999));

        setStartDate(start);
        setEndDate(end);
      }
    };

    fetchOrderData();
  }, []);

  useEffect(() => {
    console.log("hello");
    if (clicked) {
      getOrderData(
        startDate,
        endDate,
        selectedOutlet?.value || "",
        1,
        recordsPerPage,
        searchText,
        orderType,
        orderStatus
      );
    }

  }, [recordsPerPage]);

  useEffect(() => {
    getAdminUsersList();
  }, []);

  const renderPaginationItems = () => {
    if (totalPages > 15) {
      return (
        <>
          {currentPage > 3 && (
            <Pagination.Item onClick={() => handlePageChange(1)}>
              1
            </Pagination.Item>
          )}
          {currentPage > 4 && <Pagination.Ellipsis />}

          {Array.from({ length: 5 }, (_, i) => {
            const pageNumber = currentPage > 3 ? currentPage - 2 + i : i + 1;
            if (pageNumber <= totalPages) {
              return (
                <Pagination.Item
                  key={pageNumber}
                  active={pageNumber === currentPage}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              );
            }
            return null;
          })}

          {currentPage < totalPages - 3 && <Pagination.Ellipsis />}
          {currentPage < totalPages - 2 && (
            <Pagination.Item onClick={() => handlePageChange(totalPages)}>
              {totalPages}
            </Pagination.Item>
          )}
        </>
      );
    } else {
      return Array.from({ length: totalPages }, (_, i) => (
        <Pagination.Item
          key={i + 1}
          active={i + 1 === currentPage}
          onClick={() => handlePageChange(i + 1)}
        >
          {i + 1}
        </Pagination.Item>
      ));
    }
  };

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "COMPLETED":
        return "success";
      case "DELIVERED":
        return "primary";
      case "CONFIRMED":
        return "secondary";
      case "READY-TO-PICK":
        return "warning";
      case "CANCELLED":
        return "danger";
      default:
        return "dark";
    }
  };

  const getAdminUsersList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("admin-user-management", { headers });
      console.log("Response of admin users :", response.data.data.dbResponse);

      if (response?.data?.status === true) {
        response?.data?.data?.dbResponse.forEach((item, index) => {
          item.serialNumber = index + 1;
        });
        setUsersList(response?.data?.data?.dbResponse);
      }
    } catch (error) {
      console.log("Error in Fetching Admin Users :", error);

      // if (error.response && error.response?.data?.status === false) {
      //     let errorMessage = error.response.data.error;
      //     toast.error(errorMessage, {
      //         position: "top-right",
      //         autoClose: 3000,
      //         theme: "colored",
      //     });
      // }
    }
  };

  const adminUserOptions = usersList?.map((users) => ({
    value: users?._id,
    label: users?.name,
  }));

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div
        className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"
          }`}
      >
        <div>
          <div className={`card ${skin === "dark" ? "bg-dark-dark" : ""} border-0 shadow-sm`}>
            <div className="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-0 fw-bold d-inline-block">
                  <i className="bi bi-bag me-2"></i>ORDERS REPORT
                </h4>
              </div>
              <div>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => navigate('/reports/all-reports')}
                  className="me-3 d-flex align-items-center fw-semibold"
                  style={{ height: '38px' }}
                >
                  <ArrowLeft className="me-1" /> Back to Reports
                </Button>
              </div>
            </div>
            <hr className="mt-0 mb-0" />

            <div className="card-body">
              {/* Filters Section */}
              <div className="filters-section p-3 bg-light rounded-3">
                <Row className="g-3">
                  <Col md={4}>
                    <Form.Group controlId="outletSelect">
                      <OutletSelect
                        value={selectedOutlet}
                        onChange={(option) => {
                          console.log("Selected Outlet :", option);
                          setSelectedOutlet(option);
                        }}
                        required={true}
                      />

                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group controlId="outletSelect">
                      <Form.Label className="fw-semibold">
                        Select Order Status <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={orderStatus}
                        onChange={(e) => setOrderStatus(e.target.value)}
                        className="border-secondary"
                      >
                        <option value="">All</option>
                        <option value="CONFIRMED" >CONFIRMED</option>
                        <option value="CANCELLED" >CANCELLED</option>
                        <option value="COMPLETED" >COMPLETED</option>
                        <option value="DELIVERED" >DELIVERED</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group controlId="outletSelect">
                      <Form.Label className="fw-semibold">
                        Select Order Type <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={orderType}
                        onChange={(e) => setOrderType(e.target.value)}
                        className="border-secondary"
                      >
                        <option value="">All</option>
                        <option value="APP" >APP/WEBSITE ORDERS</option>
                        <option value="KIOSK" >KIOSK ORDERS</option>
                        <option value="SUBSCRIBED" >SUBSCRIPTION ORDERS</option>
                        <option value="COMPLIMENTARY" >COMPLIMENTARY ORDERS</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group controlId="datePicker">
                      <Form.Label className="fw-semibold">
                        Select Date <span className="text-danger">*</span>
                      </Form.Label>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                          setEndDate(date);
                          if (date && endDate && date.getTime() !== endDate.getTime()) {
                            setError("Start Date and End Date must be the same");
                          } else {
                            setError(null);
                          }
                        }}
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Select Date"
                        className="form-control border-secondary"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Label className="fw-light text-light">
                      .
                    </Form.Label>
                    <Button
                      variant="primary"
                      className="w-100 py-2"
                      onClick={handleSubmit}
                      disabled={subBtnLoading || selectedOutlet === "" || startDate === null}
                    >
                      {subBtnLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Generate Report"
                      )}
                    </Button>
                  </Col>
                </Row>
              </div>

              {/* Search and Actions Section */}
              <div className="actions-section mb-2 p-3 bg-light rounded-3">
                <Row className="g-3 align-items-center">
                  <Col md={6}>
                    <InputGroup>
                      <FormControl
                        type="text"
                        placeholder="Search by Name, Order Number or Mobile"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        className="border-secondary"
                      />
                      <Button
                        variant="outline-secondary"
                        onClick={handleSubmit}
                        disabled={selectedOutlet === "" || startDate === null}
                      >
                        <i className="bi bi-search me-3"></i>Search
                      </Button>
                    </InputGroup>
                  </Col>

                  <Col md={3}>
                    <Button
                      variant="outline-primary"
                      className="w-100"
                      onClick={handleSubmit}
                      disabled={selectedOutlet === "" || startDate === null}
                    >
                      {subBtnLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Refresh Results"
                      )}
                    </Button>
                  </Col>

                  <Col md={3}>
                    <Button
                      variant="outline-success"
                      className="w-100 fw-semibold"
                      disabled={downloadBtnLoading || clicked === false || filteredData?.length === 0}
                      onClick={handleDownloadExcel}
                    >
                      <FileEarmarkSpreadsheet className=" me-2" />
                      {downloadBtnLoading ? (
                        <Spinner size="sm" animation="border" />
                      ) : (
                        "Download Excel"
                      )}
                    </Button>
                  </Col>
                </Row>
              </div>

              {/* Totals Cards Section - NEW ADDITION */}
              {/* Alternative: Compact Cards Layout */}
              {clicked && filteredData?.length > 0 && (
                <div className="compact-cards-section mb-3 d-block"> {/* Add 'd-block' to use this version instead */}
                  <Row className="g-2">
                    <Col md={12}>
                      <Card className={`border-0 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                        <Card.Body className="py-2">
                          <Row className="text-center">
                            <Col md={3} className="border-end">
                              <small className={`text-muted ${skin === "dark" ? "text-light" : ""}`}>Total Orders</small>
                              <h5 className="mb-0 fw-bold mt-1">{totalRecords}</h5>
                            </Col>
                            <Col md={3} className="border-end">
                              <small className={`text-muted ${skin === "dark" ? "text-light" : ""}`}>Total Taxable</small>
                              <h5 className="mb-0 fw-bold mt-1 text-success">₹{ordersTotalTaxable?.toFixed(2)}</h5>
                            </Col>
                            <Col md={3} className="border-end">
                              <small className={`text-muted ${skin === "dark" ? "text-light" : ""}`}>Total Discount</small>
                              <h5 className="mb-0 fw-bold mt-1 text-warning">₹{ordersTotalDiscountAmt?.toFixed(2)}</h5>
                            </Col>
                            <Col md={3}>
                              <small className={`text-muted ${skin === "dark" ? "text-light" : ""}`}>Grand Total</small>
                              <h5 className="mb-0 fw-bold mt-1 text-primary">₹{ordersGrandTotal?.toFixed(2)}</h5>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </div>
              )}

              {/* Results Section */}
              {clicked === false ? (
                <div className="d-flex justify-content-center align-items-center py-5 my-5">
                  <div className="text-center">
                    <i className="bi bi-clipboard2-data fs-1 text-muted"></i>
                    <h5 className="text-muted mt-3">
                      Please select an outlet and date to view orders
                    </h5>
                  </div>
                </div>
              ) : (
                <>
                  {/* Pagination Controls - Top */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                      <span className="me-2 text-muted">Show</span>
                      <Form.Select
                        style={{ width: "auto" }}
                        value={recordsPerPage}
                        onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                        className="border-secondary"
                      >
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                      </Form.Select>
                      <span className="ms-2 text-muted">entries</span>
                    </div>
                    <Pagination className="mb-0">
                      <Pagination.Prev
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      />
                      {renderPaginationItems()}
                      <Pagination.Next
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                      />
                    </Pagination>
                  </div>

                  {/* Orders Table */}
                  <div className="table-responsive border rounded-3">
                    <Table striped bordered hover className={`mb-0 ${skin === "dark" ? "table-dark" : ""}`}>
                      <thead className={`${skin === "dark" ? "bg-dark" : "bg-light"}`}>
                        <tr>
                          <th width="50">#</th>
                          <th width="120">Order No</th>
                          <th>Customer Details</th>
                          <th width="140">Status</th>
                          {/* New Cool Arrival Column */}
                          <th width="150" className="text-center">Arrival</th>
                          <th width="160">Date & Time</th>
                          <th width="120">Coupon</th>
                          <th width="100" className="text-end">Taxable</th>
                          <th width="100" className="text-end">Tax</th>
                          <th width="100" className="text-end">Discount</th>
                          <th width="120" className="text-end">Total</th>
                          <th width="100" className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="11" className="text-center py-4">
                              <Spinner animation="border" variant="primary" />
                              <p className="mt-2 mb-0">Loading orders...</p>
                            </td>
                          </tr>
                        ) : filteredData?.length > 0 ? (
                          <>
                            {filteredData?.map((orderData, index) => (
                              <tr key={index} style={{ cursor: 'pointer' }}>
                                <td className="text-muted" onClick={() => viewOrderDetails(orderData)}>
                                  {(currentPage - 1) * recordsPerPage + index + 1}
                                </td>
                                <td onClick={() => viewOrderDetails(orderData)}>
                                  <span className="fw-semibold" >
                                    {orderData?.order?.order_sequence}
                                    {orderData?.order?.order_no}
                                  </span>
                                  {orderData?.order?.subscriptionId && (
                                    <span className="badge bg-success bg-opacity-10 text-success border border-success">
                                      Subscription
                                    </span>
                                  )}
                                </td>
                                <td onClick={() => viewOrderDetails(orderData)}>
                                  {(orderData?.order?.outletUser && orderData?.order?.paymentMode === "COMPLIMENTARY") ? (
                                    <>
                                      <div className="fw-semibold">
                                        {orderData?.order?.outletUser?.name}
                                      </div>
                                      <div className="text-primary small">
                                        {orderData?.order?.outletUser?.mobile}
                                      </div>
                                      <span className="badge bg-info mt-1">Complimentary</span>
                                    </>
                                  ) : (orderData?.order?.outletUser && orderData?.order?.paymentMode !== "COMPLIMENTARY") ? (
                                    <>
                                      <div className="fw-semibold">
                                        {orderData?.order?.outletUser?.name}
                                      </div>
                                      <div className="text-primary small">
                                        {orderData?.order?.outletUser?.mobile}
                                      </div>
                                      <span className="badge bg-primary mt-1">POS CREATED</span>
                                    </>
                                  ) : orderData?.order?.kioskUser ? (
                                    <>
                                      <div className="fw-semibold">
                                        {orderData?.order?.kioskUser?.name}
                                      </div>
                                      <div className="text-primary small">
                                        {orderData?.order?.kioskUser?.phone}
                                      </div>
                                      <span className="badge bg-warning text-dark mt-1">Kiosk</span>
                                    </>
                                  ) : (
                                    <>
                                      <div className="fw-semibold">
                                        {orderData?.order?.user?.name}
                                      </div>
                                      <div className="text-primary small">
                                        {orderData?.order?.user?.mobile}
                                      </div>
                                    </>
                                  )}
                                </td>
                                <td className="text-center" onClick={() => viewOrderDetails(orderData)}>
                                  <Badge
                                    bg={getStatusBadgeColor(orderData?.order?.orderStatus)}
                                    className="py-1 px-2"
                                  >
                                    {orderData?.order?.orderStatus}
                                  </Badge>
                                </td>

                                {/* === Arrival Status Column - Cool Version === */}
                                <td className="text-center" onClick={() => viewOrderDetails(orderData)}>
                                  {orderData?.order?.orderArrivalStatus === "DELAYED" ? (
                                    <div
                                      className="d-inline-flex align-items-center gap-2 px-3 py-2"
                                      style={{
                                        background: "rgba(220,53,69,0.1)",
                                        color: "#dc3545",
                                        borderRadius: "9px",
                                        fontSize: "11px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <i className="bi bi-clock-history"></i>
                                      <div className="text-start">
                                        <div style={{ fontWeight: 600, lineHeight: "1" }}>Delayed</div>
                                        <div style={{ fontSize: "10px" }}>
                                          +{orderData?.order?.delayedArrival} min
                                        </div>
                                      </div>
                                    </div>
                                  ) : orderData?.order?.orderArrivalStatus === "EARLY" ? (
                                    <div
                                      className="d-inline-flex align-items-center gap-2 px-3 py-2"
                                      style={{
                                        background: "rgba(25,135,84,0.1)",
                                        color: "#198754",
                                        borderRadius: "9px",
                                        fontSize: "11px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <i className="bi bi-lightning-charge-fill"></i>
                                      <div className="text-start">
                                        <div style={{ fontWeight: 600, lineHeight: "1" }}>Early</div>
                                        <div style={{ fontSize: "10px" }}>
                                          -{orderData?.order?.earlyArrival} min
                                        </div>
                                      </div>
                                    </div>
                                  ) : orderData?.order?.orderArrivalStatus === "ON_TIME" ? (
                                    <div
                                      className="d-inline-flex align-items-center gap-2 px-3 py-2"
                                      style={{
                                        background: "rgba(13,110,253,0.1)",
                                        color: "#0d6efd",
                                        borderRadius: "9px",
                                        fontSize: "11px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <i className="bi bi-check-circle"></i>
                                      <div style={{ fontWeight: 600 }}>On Time</div>
                                    </div>
                                  ) : (
                                    // <span className="text-muted fs-6">—</span>
                                    <div
                                      className="d-inline-flex align-items-center gap-2 px-3 py-2"
                                      style={{
                                        background: "rgba(13,110,253,0.1)",
                                        color: "#0d6efd",
                                        borderRadius: "9px",
                                        fontSize: "11px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <i className="bi bi-check-circle"></i>
                                      <div style={{ fontWeight: 600 }}>On Time</div>
                                    </div>
                                  )}
                                </td>

                                <td onClick={() => viewOrderDetails(orderData)}>
                                  <div className="small">
                                    {new Date(orderData?.order?.createdAt).toLocaleDateString("en-US", {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                    })}
                                  </div>
                                  <div className="text-muted small" onClick={() => viewOrderDetails(orderData)}>
                                    {new Date(orderData?.order?.createdAt).toLocaleTimeString("en-US", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                  </div>
                                </td>
                                <td className="text-center" onClick={() => viewOrderDetails(orderData)}>
                                  {orderData?.order?.coupon ? (
                                    <span className="badge bg-success bg-opacity-10 text-success">
                                      {orderData?.order?.coupon?.couponCode}
                                    </span>
                                  ) : (
                                    <span className="text-muted">--</span>
                                  )}
                                </td>
                                <td className="text-end fw-semibold" onClick={() => viewOrderDetails(orderData)}>
                                  ₹{orderData?.order?.totalTaxable?.toFixed(2)}
                                </td>
                                <td className="text-end" onClick={() => viewOrderDetails(orderData)}>
                                  ₹{orderData?.order?.totalTaxAmount?.toFixed(2)}
                                </td>
                                <td className="text-end" onClick={() => viewOrderDetails(orderData)}>
                                  ₹{orderData?.order?.totalDiscount?.toFixed(2)}
                                </td>
                                <td className="text-end fw-bold text-primary" onClick={() => viewOrderDetails(orderData)}>
                                  ₹{orderData?.order?.grandTotal?.toFixed(2)}
                                </td>
                                <td className="text-center">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="outline-primary"
                                      size="sm"
                                      id="dropdown-basic"
                                      className="px-3"
                                    >
                                      Actions
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => viewOrderDetails(orderData)}
                                      >
                                        <i className="bi bi-eye me-2 text-success"></i> View Details
                                      </Dropdown.Item>
                                      {/* {( (reportAccess?.includes("OrdersReport:update") || email === "contact@xpansecafe.com") && orderData?.order?.orderStatus !== "CANCELLED") && (
                                              <Dropdown.Item 
                                                onClick={() => handleOpenCancelOrderModal(orderData)}
                                              >
                                                <i className="bi bi-x-circle me-2 text-danger"></i> Cancel Order
                                              </Dropdown.Item>
                                            )} */}
                                      {((reportAccess?.includes("OrdersReport:update") || email === "contact@xpansecafe.com") &&
                                        (orderData?.order?.orderStatus !== "CANCELLED" && new Date(orderData?.order?.createdAt).toDateString() === currentDate.toDateString()) && orderData?.order?.paymentMode !== "COMPLIMENTARY") && (
                                          <Dropdown.Item
                                            onClick={() => handleOpenCancelOrderModal(orderData)}
                                          >
                                            <i className="bi bi-x-circle me-2 text-danger"></i> Cancel Order
                                          </Dropdown.Item>
                                        )}
                                      <Dropdown.Item
                                        onClick={() => handlePrintInvoice(orderData)}
                                      >
                                        <i className="bi bi-receipt me-2 text-primary"></i> Print Invoice
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                              </tr>
                            ))}

                            {/* Grand Total Row */}
                            {currentPage === lastPage && (
                              <tr className="fw-bold">
                                <td colSpan="7" className="text-end">
                                  Grand Total:
                                </td>
                                <td className="text-end">₹ {ordersTotalTaxable?.toFixed(2)}</td>
                                <td className="text-end">₹ {ordersTotalTaxAmt?.toFixed(2)}</td>
                                <td className="text-end">₹ {ordersTotalDiscountAmt?.toFixed(2)}</td>
                                <td className="text-end text-success">₹ {ordersGrandTotal?.toFixed(2)}</td>
                                <td></td>
                              </tr>
                            )}
                          </>
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center py-4">
                              <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                              <p className="mt-2 mb-0 text-muted">
                                {errorMsg || "No orders found for the selected criteria"}
                              </p>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination Controls - Bottom */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                      Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                      {Math.min(currentPage * recordsPerPage, filteredData?.length)} of{" "}
                      {filteredData?.length} entries
                    </div>
                    <Pagination>
                      <Pagination.Prev
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      />
                      {renderPaginationItems()}
                      <Pagination.Next
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                      />
                    </Pagination>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Cancel Order Modal */}
        {openCancelOrderModal && (
          <Modal
            show={openCancelOrderModal}
            onHide={handleCloseCancelOrderModal}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Cancel Order</Modal.Title>
            </Modal.Header>

            <Form onSubmit={
              cancelOrderData?.order?.subscriptionId ? handleCancelSubsOrder : handleCancelNormalOrder
            }
            >
              <Modal.Body>
                {/* {error && <Alert variant="danger">{error}</Alert>} */}

                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Refund Type <span className="text-danger">*</span></Form.Label>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          label="Instant Refund"
                          name="refundType"
                          value="INSTANT"
                          checked={refundType === 'INSTANT'}
                          onChange={(e) => setRefundType(e.target.value)}
                          id="refund-instant"
                        />
                        <Form.Check
                          inline
                          type="radio"
                          label="Normal Refund"
                          name="refundType"
                          value="NORMAL"
                          checked={refundType === 'NORMAL'}
                          onChange={(e) => setRefundType(e.target.value)}
                          id="refund-normal"
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  {/* <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Stock Management <span className="text-danger">*</span></Form.Label>
                            <Form.Check
                              type="checkbox"
                              label="Restore items to inventory"
                              checked={isStockRefund}
                              onChange={(e) => setIsStockRefund(e.target.checked)}
                              id="stock-refund"
                            />
                          </Form.Group>
                        </Col> */}

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">
                        Stock Management <span className="text-danger">*</span>
                      </Form.Label>
                      <div>
                        <Form.Check
                          type="radio"
                          label="Restore items to inventory"
                          name="stock-refund"
                          checked={isStockRefund === true}
                          onChange={() => setIsStockRefund(true)}
                          id="stock-refund-true"
                        />
                        <Form.Check
                          type="radio"
                          label="Do not restore items to inventory"
                          name="stock-refund"
                          checked={isStockRefund === false}
                          onChange={() => setIsStockRefund(false)}
                          id="stock-refund-false"
                        />
                      </div>
                    </Form.Group>
                  </Col>


                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold">Approved From <span className="text-danger">*</span></Form.Label>
                      <Select
                        options={adminUserOptions}
                        value={adminUserOptions.find(option => option.value === selectedAdminUser)}
                        onChange={(selectedOption) => {
                          const selectCategory = selectedOption?.value;
                          setSelectedAdminUser(selectCategory);
                        }}
                        isClearable
                        styles={customStyles}
                        placeholder="Select Approver"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Reason for Cancellation <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Please provide a reason for canceling this order"
                    required
                  />
                </Form.Group>

                {/* <div className="text-muted small">
                        <p><strong>Note:</strong></p>
                        <ul>
                          <li>Instant refunds are processed immediately to the original payment method</li>
                          <li>Normal refunds may take 5-7 business days to process</li>
                          <li>Restoring items to inventory will make them available for purchase again</li>
                        </ul>
                      </div> */}
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="outline-secondary"
                  onClick={handleCloseCancelOrderModal}
                  disabled={cancelBtnLoading}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  type="submit"
                  disabled={cancelBtnLoading || !reason.trim()}
                >
                  {cancelBtnLoading ? <Spinner size="sm" animation="border" /> : 'Confirm Cancellation'}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        )}

        {/* Modal for Viewing Order Details */}
        <Modal
          show={viewDetailsModal}
          onHide={closeModal}
          size="lg"
          centered
        >
          <Modal.Header closeButton className="border-0">
            <Modal.Title className="w-100 text-center">
              {selectedOrder?.order?.paymentMode === "SUBSCRIBED" ? (
                <div className="d-flex justify-content-center align-items-center">
                  <span className="fs-4 me-2">🔄</span>
                  <span className="fw-bold text-primary">SUBSCRIPTION ORDER DETAILS</span>
                  <span className="fs-4 ms-2">📦</span>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <span className="fs-4 me-2">🛒</span>
                  <span className="fw-bold text-muted">ORDER DETAILS</span>
                  <span className="fs-4 ms-2">🧾</span>
                </div>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedOrder ? (
              <div className="p-3">
                <Row className="mb-2">
                  <Col xs={4}>
                    <h6>Order No:</h6>
                    <p>{selectedOrder?.order?.order_sequence}{selectedOrder?.order?.order_no}</p>
                  </Col>
                  <Col xs={4}>
                    <h6>Order Type :</h6>
                    <p>{selectedOrder?.order?.ordersType}</p>
                  </Col>
                  <Col xs={4}>
                    <h6>Outlet Name :</h6>
                    <p>
                      {selectedOrder?.orderStatusLogs[0]?.outlet?.name}
                    </p>
                  </Col>

                </Row>
                <Row className="mb-2">
                  <Col xs={4}>
                    <h6>Date & Time:</h6>
                    <p>
                      {new Date(selectedOrder?.order?.createdAt).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}{" / "}
                      {new Date(selectedOrder?.order?.createdAt).toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true,
                      })}
                    </p>
                  </Col>
                  <Col xs={4}>
                    <h6>User Name :</h6>
                    <p>
                      {selectedOrder?.order?.outletUser
                        ? `${selectedOrder?.order?.outletUser?.name}`
                        : selectedOrder?.order?.kioskUser
                          ? `${selectedOrder?.order?.kioskUser?.name} [Kiosk User]`
                          : selectedOrder?.order?.user?.name}
                    </p>
                  </Col>
                  <Col xs={4}>
                    <h6>Mobile Number :</h6>
                    <p>
                      {selectedOrder?.order?.outletUser
                        ? selectedOrder?.order?.outletUser?.mobile
                        : selectedOrder?.order?.kioskUser
                          ? selectedOrder?.order?.kioskUser?.phone
                          : selectedOrder?.order?.user?.mobile}
                    </p>
                  </Col>

                  <Col xs={4}>
                    <h6>Source :</h6>
                    <p>
                      {selectedOrder?.order?.source}
                      {/* {selectedOrder?.order?.outletUser
                              ? "Complimentary Order"
                              : selectedOrder?.order?.kioskUser
                              ? "Kiosk"
                              : "APP"} */}
                    </p>
                  </Col>
                  <Col xs={4}>
                    <h6>Status :</h6>
                    <Badge
                      bg={
                        selectedOrder?.order?.orderStatus === "COMPLETED"
                          ? "success"
                          : selectedOrder?.order?.orderStatus === "DELIVERED"
                            ? "primary"
                            : selectedOrder?.order?.orderStatus === "CONFIRMED"
                              ? "secondary"
                              : selectedOrder?.order?.orderStatus === "READY-TO-PICK"
                                ? "warning"
                                : "danger"
                      }
                      className="py-1 px-2"
                    >
                      {selectedOrder?.order?.orderStatus}
                    </Badge>
                  </Col>
                  <Col xs={4}>
                    <h6>Payment Gateway :</h6>
                    <p className="fw-semibold" style={{ color: selectedOrder?.order?.paymentGatewayProvider === "RAZORPAY" ? 'orangered' : 'blueviolet' }}>
                      {selectedOrder?.order?.paymentMode === "COMPLIMENTARY" ? "COMPLIMENTARY" : selectedOrder?.order?.paymentGatewayProvider} <br />
                      {selectedOrder?.order?.razorpayOrderId &&
                        <span className="text-muted pt-0" style={{ fontSize: '12px' }}>[{selectedOrder?.order?.razorpayOrderId}]</span>
                      }
                    </p>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={4}>
                    <h6>Payment Status :</h6>
                    <Badge
                      bg={
                        selectedOrder.order?.paymentStatus === "PAID"
                          ? "success"
                          : "danger"
                      }
                      className="py-1 px-2"
                    >
                      {selectedOrder?.order?.paymentStatus}
                    </Badge>
                  </Col>
                  <Col xs={4}>
                    <h6>Pickup Option :</h6>
                    <p>{selectedOrder?.order?.pickupOption}</p>
                  </Col>
                  <Col xs={4}>
                    <h6>Coupon Applied :</h6>
                    <p>{selectedOrder?.order?.coupon ? "YES" : "NO"}</p>
                  </Col>
                  <Col xs={4}>
                    <h6>Arrival Status :</h6>
                    {selectedOrder?.order?.orderArrivalStatus === "DELAYED" ? (
                      <div className="d-inline-flex align-items-center gap-2 px-3 py-2"
                        style={{ background: "rgba(220,53,69,0.1)", color: "#dc3545", borderRadius: "9px", fontSize: "12px", fontWeight: 500 }}>
                        <i className="bi bi-clock-history"></i>
                        <div>
                          <div style={{ fontWeight: 600 }}>Delayed</div>
                          <div style={{ fontSize: "11px" }}>+{selectedOrder?.order?.delayedArrival} min late</div>
                        </div>
                      </div>
                    ) : selectedOrder?.order?.orderArrivalStatus === "EARLY" ? (
                      <div className="d-inline-flex align-items-center gap-2 px-3 py-2"
                        style={{ background: "rgba(25,135,84,0.1)", color: "#198754", borderRadius: "9px", fontSize: "12px", fontWeight: 500 }}>
                        <i className="bi bi-lightning-charge-fill"></i>
                        <div>
                          <div style={{ fontWeight: 600 }}>Early</div>
                          <div style={{ fontSize: "11px" }}>-{selectedOrder?.order?.earlyArrival} min ahead</div>
                        </div>
                      </div>
                    ) : (
                      <div className="d-inline-flex align-items-center gap-2 px-3 py-2"
                        style={{ background: "rgba(13,110,253,0.1)", color: "#0d6efd", borderRadius: "9px", fontSize: "12px", fontWeight: 500 }}>
                        <i className="bi bi-check-circle-fill"></i>
                        <div style={{ fontWeight: 600 }}>On Time</div>
                      </div>
                    )}
                  </Col>
                </Row>
                {/* <Row className="mb-2">
                        
                      </Row> */}

                {selectedOrder?.order?.coupon && (
                  <Row className="mb-2">
                    <Col xs={4} md={4}>
                      <h6>Coupon Name :</h6>
                      <p>{selectedOrder?.order?.coupon?.title}</p>
                    </Col>
                    <Col xs={4} md={4}>
                      <h6>Coupon Code :</h6>
                      <p className="text-danger">{selectedOrder?.order?.coupon?.couponCode}</p>
                    </Col>
                    <Col xs={4} md={4}>
                      <h6>Usage Type :</h6>
                      <p>{selectedOrder?.order?.coupon?.usageType}</p>
                    </Col>
                  </Row>
                )}

                {selectedOrder?.order?.comments && (
                  <Row className="mb-2">
                    <Col xs={12} md={12}>
                      <h6>Remark :</h6>
                      <p>{selectedOrder?.order?.comments}</p>
                    </Col>
                  </Row>
                )}

                <Row className="mb-1">
                  <Col xs={12}>
                    <h6>Ordered Items :</h6>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th className="fw-semibold">Product</th>
                          <th className="text-center fw-semibold">Quantity</th>
                          <th className="text-center fw-semibold">Price</th>
                          <th className="text-center fw-semibold">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedOrder?.orderItems?.map((item) => (
                          <tr key={item._id}>
                            <td>{item?.product?.name}
                              {item?.addons?.length > 0 && (
                                <ul style={{ fontSize: '14px' }}>
                                  {item.addons.map((addon) => (
                                    <li key={addon._id}>
                                      {addon.selectedValue} (₹{addon.price})
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </td>
                            <td className="text-center">{item?.quantity}</td>
                            <td className="text-end">
                              ₹{selectedOrder?.order?.coupon?.isMrpDiscount && item.discount > 0 ? item.mrpRate.toFixed(2) : item.rate.toFixed(2)}
                              {item?.addons?.length > 0 && (
                                <ul style={{ fontSize: '14px', listStyleType: 'none' }}>
                                  {item?.addons?.map((addon) => (
                                    <li key={addon._id}>
                                      + (₹{addon?.price})
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </td>
                            <td className="text-end">
                              ₹{getItemTotal(item).toFixed(2)}
                            </td>
                          </tr>
                        ))}

                        {selectedOrder?.order?.platformFees !== 0 && (
                          <tr>
                            <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>
                              Platform Fees:
                            </td>
                            <td style={{ fontSize: '14px' }} className="text-end">
                              ₹ {Number(selectedOrder?.order?.platformFees).toFixed(2)}
                            </td>
                          </tr>
                        )}

                        {selectedOrder?.order?.packingCharges !== 0 && (
                          <tr>
                            <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Packing Fees:</td>
                            <td style={{ fontSize: '14px' }} className="text-end">
                              ₹ {selectedOrder?.order?.packingCharges ? selectedOrder?.order?.packingCharges?.toFixed(2) : "0"}
                            </td>
                          </tr>
                        )}

                        {selectedOrder?.order?.deliveryCharges !== 0 && (
                          <tr>
                            <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Delivery Charges:</td>
                            <td style={{ fontSize: '14px' }} className="text-end">
                              ₹ {selectedOrder?.order?.deliveryCharges?.toFixed(2)}
                            </td>
                          </tr>
                        )}

                        <tr>
                          <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Total :</td>
                          <td style={{ fontSize: '14px' }} className="text-end">
                            ₹ {calculateTotal()}
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #9e9b9b' }}>
                          <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Total Discount:</td>
                          <td style={{ fontSize: '14px' }} className="text-end">
                            (-) ₹ {selectedOrder?.order?.totalDiscount?.toFixed(2)}
                          </td>
                        </tr>

                        <tr>
                          <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}></td>
                          <td style={{ fontSize: '14px' }} className="text-end text-muted fw-semibold">
                            ₹ {(calculateTotal() - (selectedOrder?.order?.totalDiscount || 0)).toFixed(2)}
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #000' }}>
                          <td colSpan={3} className="text-end" style={{ fontSize: '14px' }}>Total Tax Amount:</td>
                          <td style={{ fontSize: '14px' }} className="text-end">
                            (+) ₹ {selectedOrder?.order?.totalTaxAmount?.toFixed(2)}
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #000' }}>
                          <td colSpan={3} className="text-end"><strong>Grand Total:</strong></td>
                          <td className="text-end fw-semibold">
                            ₹ {selectedOrder?.orderItems?.reduce((total, item) => total + item.grandTotal, 0).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>

                <Row className="mb-1">
                  <Col xs={12}>
                    <h6>Order Status Log :</h6>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th className="fw-semibold">Order Status</th>
                          <th className="fw-semibold">Time</th>
                          <th className="fw-semibold">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedOrder?.orderStatusLogs?.length > 0 ? (
                          selectedOrder.orderStatusLogs.map((log) => (
                            <tr key={log._id}>
                              <td>
                                <Badge
                                  bg={
                                    log.orderStatus === "COMPLETED"
                                      ? "success"
                                      : log.orderStatus === "DELIVERED"
                                        ? "primary"
                                        : log.orderStatus === "CONFIRMED"
                                          ? "secondary"
                                          : log.orderStatus === "READY-TO-PICK"
                                            ? "warning"
                                            : log.orderStatus === "CANCELLED"
                                              ? "danger"
                                              : "dark"
                                  }
                                  className="py-1 px-2"
                                >
                                  {log.orderStatus}
                                </Badge>
                              </td>
                              <td>
                                {new Date(log.createdAt).toLocaleTimeString('en-US', {
                                  hour: 'numeric',
                                  minute: 'numeric',
                                  hour12: true,
                                })}
                              </td>
                              <td>
                                {new Date(log.createdAt).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'long',
                                  day: 'numeric',
                                })}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3} className="text-center">
                              No order status logs available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>
            ) : (
              <p>No order details available.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default OrdersReport;



// import React, { useEffect, useState, useRef } from "react";
// import axios from "../../api/axios";
// import {
//   Row,
//   Col,
//   Button,
//   Form,
//   Table,
//   Modal,
//   Badge,
//   Spinner,
//   Pagination,
//   InputGroup,
//   FormControl,
// } from "react-bootstrap";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { toast } from "react-toastify";
// import Header from "../../layouts/Header";
// import {
//   ArrowLeft,
//   FileEarmarkSpreadsheet,
//   Shop,
//   Table as TableIcon,
//   Search,
//   ArrowClockwise,
//   ChevronDown,
//   X,
//   Eye,
//   Receipt,
//   XCircle,
//   BoxArrowDown,
// } from "react-bootstrap-icons";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import Select from "react-select";
// import makeAnimated from "react-select/animated";
// import OutletSelect from "../../components/OutletSelect";

// /* ─────────────────────────────────────────────────────────
//    INLINE STYLES  (no external CSS file needed)
// ───────────────────────────────────────────────────────── */
// const CSS = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&family=Outfit:wght@300;400;500;600;700&display=swap');

//   :root {
//     --or-bg: #f0f2f5;
//     --or-surface: #ffffff;
//     --or-border: #e2e6ea;
//     --or-text: #1a202c;
//     --or-muted: #41505F;
//     --or-accent: #2563eb;
//     --or-accent-light: #eff6ff;
//     --or-accent-dark: #1d4ed8;
//     --or-success: #059669;
//     --or-success-light: #ecfdf5;
//     --or-warning: #d97706;
//     --or-warning-light: #fffbeb;
//     --or-danger: #dc2626;
//     --or-danger-light: #fef2f2;
//     --or-info: #0891b2;
//     --or-info-light: #ecfeff;
//     --or-shadow-sm: 0 1px 3px rgba(0,0,0,.08), 0 1px 2px rgba(0,0,0,.05);
//     --or-shadow-md: 0 4px 12px rgba(0,0,0,.09), 0 2px 4px rgba(0,0,0,.06);
//     --or-shadow-lg: 0 10px 40px rgba(0,0,0,.12);
//     --or-radius: 10px;
//     --or-radius-sm: 8px;
//     --or-radius-xs: 6px;
//   }

//   // .or-root { font-family: 'Outfit', sans-serif; }

//   /* ── Page shell ── */
//   .or-page {
//     min-height: 100vh;
//     background: var(--or-bg);
//     padding: 24px;
//   }

//   /* ── Card ── */
//   .or-card {
//     background: var(--or-surface);
//     border-radius: var(--or-radius);
//     box-shadow: var(--or-shadow-md);
//     border: 1px solid var(--or-border);
//     overflow: hidden;
//   }

//   /* ── Card header ── */
//   .or-header {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 20px 28px;
//     border-bottom: 1px solid var(--or-border);
//     background: var(--or-surface);
//   }
//   .or-header-title {
//     font-size: 18px;
//     font-weight: 700;
//     color: var(--or-text);
//     letter-spacing: -.3px;
//     display: flex;
//     align-items: center;
//     gap: 10px;
//   }
//   .or-header-title .icon-box {
//     width: 36px;
//     height: 36px;
//     border-radius: 8px;
//     background: var(--or-accent);
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     color: #fff;
//     font-size: 15px;
//   }

//   /* ── Back button ── */
//   .or-back-btn {
//     display: flex;
//     align-items: center;
//     gap: 6px;
//     padding: 8px 16px;
//     border-radius: var(--or-radius-xs);
//     border: 1.5px solid var(--or-border);
//     background: var(--or-surface);
//     color: var(--or-muted);
//     font-size: 13px;
//     font-weight: 500;
//     cursor: pointer;
//     transition: all .18s;
//     // font-family: 'Outfit', sans-serif;
//     text-decoration: none;
//   }
//   .or-back-btn:hover {
//     border-color: var(--or-accent);
//     color: var(--or-accent);
//     background: var(--or-accent-light);
//   }

//   /* ── Filters panel ── */
//   .or-filters {
//     padding: 20px 28px;
//     border-bottom: 1px solid var(--or-border);
//     background: #fafbfc;
//   }
//   .or-filter-label {
//     font-size: 13.6px;
//     font-weight: 600;
//     color: var(--or-muted);
//     letter-spacing: .8px;
//     margin-bottom: 6px;
//     display: block;
//   }
//   .or-generate-btn {
//     height: 36px;
//     padding: 0 20px;
//     border-radius: var(--or-radius-xs);
//     background: var(--or-accent);
//     border: none;
//     color: #fff;
//     font-size: 13.5px;
//     font-weight: 600;
//     cursor: pointer;
//     transition: background .18s, transform .12s;
//     display: inline-flex;
//     align-items: center;
//     gap: 7px;
//     // font-family: 'Outfit', sans-serif;
//   }
//   .or-generate-btn:hover:not(:disabled) { background: var(--or-accent-dark); transform: translateY(-1px); }
//   .or-generate-btn:disabled { opacity: .55; cursor: not-allowed; }

//   /* ── KPI strip ── */
//   .or-kpi-strip {
//     display: grid;
//     grid-template-columns: repeat(6, 1fr);
//     gap: 0;
//     border-radius: var(--or-radius);
//     border: 1px solid var(--or-border);
//     overflow: hidden;
//     box-shadow: var(--or-shadow-sm);
//     margin: 20px 28px 0;
//   }
//   .or-kpi-cell {
//     padding: 16px 18px;
//     border-right: 1px solid var(--or-border);
//     text-align: center;
//     background: var(--or-surface);
//     transition: background .15s;
//   }
//   .or-kpi-cell:last-child { border-right: none; }
//   .or-kpi-cell:hover { background: #fafbfc; }
//   .or-kpi-label {
//     font-size: 10.5px;
//     font-weight: 600;
//     color: var(--or-muted);
//     text-transform: uppercase;
//     letter-spacing: .6px;
//     margin-bottom: 6px;
//   }
//   .or-kpi-value {
//     font-size: 17px;
//     font-weight: 700;
//     // font-family: 'DM Mono', monospace;
//     letter-spacing: -.5px;
//   }
//   .or-kpi-value.blue  { color: var(--or-accent); }
//   .or-kpi-value.green { color: var(--or-success); }
//   .or-kpi-value.amber { color: var(--or-warning); }
//   .or-kpi-value.red   { color: var(--or-danger); }
//   .or-kpi-value.ink   { color: var(--or-text); }
//   .or-kpi-value.teal  { color: var(--or-info); }

//   /* ── Outlet cards ── */
//   .or-outlet-grid {
//     display: grid;
//     grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
//     gap: 12px;
//     padding: 20px 28px 0;
//   }
//   .or-outlet-card {
//     border: 1.5px solid var(--or-border);
//     border-radius: var(--or-radius-sm);
//     padding: 14px 16px;
//     background: var(--or-surface);
//     cursor: pointer;
//     transition: border-color .18s, box-shadow .18s, transform .12s;
//     box-shadow: var(--or-shadow-sm);
//   }
//   .or-outlet-card:hover {
//     border-color: var(--or-accent);
//     box-shadow: 0 0 0 3px rgba(37,99,235,.08);
//     transform: translateY(-1px);
//   }
//   .or-outlet-card.active {
//     border-color: var(--or-accent);
//     background: var(--or-accent-light);
//     box-shadow: 0 0 0 3px rgba(37,99,235,.12);
//   }
//   .or-outlet-name {
//     font-size: 13.5px;
//     font-weight: 700;
//     color: var(--or-text);
//     margin-bottom: 10px;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//   }
//   .or-outlet-stats {
//     display: grid;
//     grid-template-columns: repeat(5, 1fr);
//     gap: 4px;
//   }
//   .or-outlet-stat {
//     text-align: center;
//     padding: 6px 4px;
//     border-radius: 6px;
//     background: #f8fafc;
//   }
//   .or-outlet-stat-label { font-size: 9.5px; color: var(--or-muted); font-weight: 600; text-transform: uppercase; letter-spacing: .4px; }
//   .or-outlet-stat-val { font-size: 11.5px; font-weight: 700; 
//   // font-family: 'DM Mono', 
//   monospace; margin-top: 2px; }

//   /* ── Toolbar ── */
//   .or-toolbar {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 16px 28px;
//     gap: 12px;
//     flex-wrap: wrap;
//     border-bottom: 1px solid var(--or-border);
//   }
//   .or-toolbar-left { display: flex; align-items: center; gap: 8px; flex: 1; min-width: 260px; }
//   .or-toolbar-right { display: flex; align-items: center; gap: 8px; }

//   .or-search-wrap {
//     position: relative;
//     flex: 1;
//     max-width: 380px;
//   }
//   .or-search-wrap .search-icon {
//     position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
//     color: var(--or-muted); pointer-events: none; font-size: 14px;
//   }
//   .or-search-input {
//     width: 100%;
//     padding: 9px 12px 9px 36px;
//     border: 1.5px solid var(--or-border);
//     border-radius: var(--or-radius-xs);
//     font-size: 13.5px;
//     // font-family: 'Outfit', sans-serif;
//     background: var(--or-surface);
//     color: var(--or-text);
//     transition: border-color .18s, box-shadow .18s;
//     outline: none;
//   }
//   .or-search-input:focus {
//     border-color: var(--or-accent);
//     box-shadow: 0 0 0 3px rgba(37,99,235,.10);
//   }

//   /* View toggles */
//   .or-view-toggle { display: flex; background: #f0f2f5; border-radius: 8px; padding: 3px; gap: 2px; }
//   .or-view-btn {
//     display: flex; align-items: center; gap: 6px;
//     padding: 6px 14px;
//     border: none; background: transparent;
//     border-radius: 6px;
//     font-size: 12.5px; font-weight: 500;
//     color: var(--or-muted);
//     cursor: pointer;
//     transition: all .18s;
//     // font-family: 'Outfit', sans-serif;
//     white-space: nowrap;
//   }
//   .or-view-btn.active {
//     background: var(--or-surface);
//     color: var(--or-accent);
//     font-weight: 600;
//     box-shadow: var(--or-shadow-sm);
//   }

//   /* Outlet pill tabs */
//   .or-tab-strip {
//     display: flex;
//     gap: 6px;
//     padding: 0 28px 16px;
//     flex-wrap: wrap;
//     align-items: center;
//   }
//   .or-tab {
//     display: inline-flex; align-items: center; gap: 5px;
//     padding: 5px 14px;
//     border-radius: 20px;
//     font-size: 12.5px; font-weight: 500;
//     cursor: pointer;
//     border: 1.5px solid var(--or-border);
//     background: var(--or-surface);
//     color: var(--or-muted);
//     transition: all .18s;
//     // font-family: 'Outfit', sans-serif;
//   }
//   .or-tab:hover { border-color: var(--or-accent); color: var(--or-accent); }
//   .or-tab.active {
//     background: var(--or-accent);
//     border-color: var(--or-accent);
//     color: #fff;
//     font-weight: 600;
//   }
//   .or-tab .count {
//     font-size: 10px;
//     padding: 1px 6px;
//     border-radius: 10px;
//     background: rgba(0,0,0,.12);
//     font-weight: 600;
//   }
//   .or-tab.active .count { background: rgba(255,255,255,.25); }

//   /* ── Table ── */
//   .or-table-wrap {
//     overflow-x: auto;
//     margin: 0 28px 20px;
//     border-radius: var(--or-radius-sm);
//     border: 1px solid var(--or-border);
//     box-shadow: var(--or-shadow-sm);
//   }
//   .or-table {
//     width: 100%;
//     border-collapse: collapse;
//     font-size: 13px;
//     // font-family: 'Outfit', sans-serif;
//   }
//   .or-table thead th {
//     padding: 11px 14px;
//     background: #f8fafc;
//     border-bottom: 1px solid var(--or-border);
//     font-size: 11px;
//     font-weight: 700;
//     color: var(--or-muted);
//     text-transform: uppercase;
//     letter-spacing: .6px;
//     white-space: nowrap;
//   }
//   .or-table tbody tr {
//     border-bottom: 1px solid #f0f2f5;
//     transition: background .12s;
//   }
//   .or-table tbody tr:last-child { border-bottom: none; }
//   .or-table tbody tr:hover { background: #f8fafc; }
//   .or-table td {
//     padding: 11px 14px;
//     vertical-align: middle;
//     color: var(--or-text);
//   }
//   .or-table .row-clickable { cursor: pointer; }
//   .or-table .totals-row td {
//     background: #f0f7ff;
//     font-weight: 700;
//     font-size: 12px;
//     color: var(--or-accent-dark);
//     border-top: 2px solid var(--or-accent);
//   }

//   /* order number mono */
//   .or-orderno {
//     // font-family: 'DM Mono', monospace;
//     font-size: 12.5px;
//     font-weight: 500;
//     color: var(--or-text);
//     background: #f0f2f5;
//     padding: 2px 7px;
//     border-radius: 4px;
//     white-space: nowrap;
//   }

//   /* ── Status badges ── */
//   .or-badge {
//     display: inline-flex; align-items: center; gap: 4px;
//     padding: 3px 9px; border-radius: 20px;
//     font-size: 11px; font-weight: 700;
//     letter-spacing: .2px; white-space: nowrap;
//   }
//   .or-badge-dot { width: 5px; height: 5px; border-radius: 50%; }
//   .or-badge.completed  { background: var(--or-success-light); color: var(--or-success); }
//   .or-badge.delivered  { background: var(--or-accent-light);  color: var(--or-accent); }
//   .or-badge.confirmed  { background: #f3f4f6; color: #374151; }
//   .or-badge.ready      { background: var(--or-warning-light); color: var(--or-warning); }
//   .or-badge.cancelled  { background: var(--or-danger-light);  color: var(--or-danger); }
//   .or-badge.default    { background: #f3f4f6; color: #374151; }

//   /* arrival */
//   .or-arrival {
//     display: inline-flex; align-items: center; gap: 4px;
//     padding: 3px 9px; border-radius: 20px;
//     font-size: 11px; font-weight: 600; white-space: nowrap;
//   }
//   .or-arrival.delayed  { background: var(--or-danger-light);  color: var(--or-danger); }
//   .or-arrival.early    { background: var(--or-success-light); color: var(--or-success); }
//   .or-arrival.ontime   { background: var(--or-accent-light);  color: var(--or-accent); }

//   /* mono amounts */
//   .or-amount {
//     // font-family: 'DM Mono', monospace;
//     font-size: 12.5px;
//     font-weight: 500;
//     white-space: nowrap;
//   }
//   .or-amount.green { color: var(--or-success); }
//   .or-amount.amber { color: var(--or-warning); }
//   .or-amount.red   { color: var(--or-danger); }
//   .or-amount.blue  { color: var(--or-accent); font-weight: 700; }

//   /* action dropdown */
//   .or-action-btn {
//     padding: 5px 12px;
//     border-radius: var(--or-radius-xs);
//     border: 1.5px solid var(--or-border);
//     background: var(--or-surface);
//     font-size: 12px;
//     font-weight: 500;
//     color: var(--or-muted);
//     cursor: pointer;
//     display: inline-flex; align-items: center; gap: 5px;
//     transition: all .15s;
//     // font-family: 'Outfit', sans-serif;
//     position: relative;
//   }
//   .or-action-btn:hover { border-color: var(--or-accent); color: var(--or-accent); background: var(--or-accent-light); }

//   /* dropdown menu */
//   .or-dropdown { position: relative; }
//   .or-dropdown-menu {
//     position: absolute;
//     right: 0;
//     top: calc(100% + 6px);
//     background: var(--or-surface);
//     border: 1.5px solid var(--or-border);
//     border-radius: var(--or-radius-sm);
//     box-shadow: var(--or-shadow-lg);
//     z-index: 100;
//     min-width: 165px;
//     overflow: hidden;
//     animation: or-drop-in .14s ease;
//   }
//   @keyframes or-drop-in {
//     from { opacity: 0; transform: translateY(-6px); }
//     to   { opacity: 1; transform: translateY(0); }
//   }
//   .or-dropdown-item {
//     display: flex; align-items: center; gap: 9px;
//     padding: 9px 14px;
//     font-size: 13px; font-weight: 500;
//     color: var(--or-text);
//     cursor: pointer;
//     transition: background .12s;
//     // font-family: 'Outfit', sans-serif;
//     border: none; background: none; width: 100%; text-align: left;
//   }
//   .or-dropdown-item:hover { background: #f8fafc; }
//   .or-dropdown-item.danger { color: var(--or-danger); }
//   .or-dropdown-item.danger:hover { background: var(--or-danger-light); }

//   /* ── Pagination ── */
//   .or-pagination {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 14px 28px 20px;
//     flex-wrap: wrap;
//     gap: 12px;
//   }
//   .or-page-info { font-size: 12.5px; color: var(--or-muted); }
//   .or-per-page {
//     display: flex; align-items: center; gap: 8px; font-size: 12.5px; color: var(--or-muted);
//   }
//   .or-per-page select {
//     padding: 5px 10px;
//     border: 1.5px solid var(--or-border);
//     border-radius: var(--or-radius-xs);
//     font-size: 12.5px;
//     // font-family: 'Outfit', sans-serif;
//     background: var(--or-surface);
//     color: var(--or-text);
//     cursor: pointer;
//     outline: none;
//   }

//   /* ── Empty / loading states ── */
//   .or-empty {
//     display: flex; flex-direction: column; align-items: center; justify-content: center;
//     padding: 72px 24px;
//     color: var(--or-muted);
//     text-align: center;
//   }
//   .or-empty-icon { font-size: 44px; margin-bottom: 14px; opacity: .4; }
//   .or-empty-title { font-size: 16px; font-weight: 600; color: #374151; margin-bottom: 6px; }
//   .or-empty-sub { font-size: 13px; color: var(--or-muted); max-width: 320px; }
//   .or-loading {
//     display: flex; flex-direction: column; align-items: center; justify-content: center;
//     padding: 60px;
//     gap: 14px;
//     color: var(--or-muted);
//   }

//   /* ── Secondary toolbar btn ── */
//   .or-toolbar-btn {
//     height: 38px;
//     padding: 0 14px;
//     border-radius: var(--or-radius-xs);
//     border: 1.5px solid var(--or-border);
//     background: var(--or-surface);
//     font-size: 12.5px;
//     font-weight: 500;
//     color: var(--or-muted);
//     cursor: pointer;
//     display: inline-flex; align-items: center; gap: 6px;
//     transition: all .18s;
//     // font-family: 'Outfit', sans-serif;
//     white-space: nowrap;
//   }
//   .or-toolbar-btn:hover:not(:disabled) { border-color: var(--or-accent); color: var(--or-accent); background: var(--or-accent-light); }
//   .or-toolbar-btn.success { color: var(--or-success); border-color: #a7f3d0; }
//   .or-toolbar-btn.success:hover:not(:disabled) { background: var(--or-success-light); border-color: var(--or-success); }
//   .or-toolbar-btn:disabled { opacity: .5; cursor: not-allowed; }

//   /* ── Modal ── */
//   .or-modal-header { border-bottom: 1px solid var(--or-border) !important; padding: 18px 24px !important; }
//   .or-modal-title { font-family: 'Outfit', sans-serif; font-size: 16px; font-weight: 700; }
//   .or-modal-body { padding: 20px 24px !important; }
//   .or-modal-detail-label { font-size: 10.5px; font-weight: 700; color: var(--or-muted); text-transform: uppercase; letter-spacing: .7px; margin-bottom: 4px; }
//   .or-modal-detail-val { font-size: 14px; font-weight: 500; color: var(--or-text); }

//   .or-detail-grid {
//     display: grid;
//     grid-template-columns: repeat(3, 1fr);
//     gap: 16px;
//     margin-bottom: 20px;
//   }
//   .or-detail-cell {
//     padding: 12px 14px;
//     background: #f8fafc;
//     border-radius: var(--or-radius-sm);
//     border: 1px solid var(--or-border);
//   }

//   /* ── Responsive ── */
//   @media (max-width: 768px) {
//     .or-kpi-strip { grid-template-columns: repeat(3,1fr); }
//     .or-detail-grid { grid-template-columns: repeat(2,1fr); }
//     .or-page { padding: 12px; }
//   }
//   @media (max-width: 480px) {
//     .or-kpi-strip { grid-template-columns: repeat(2,1fr); }
//     .or-detail-grid { grid-template-columns: 1fr; }
//   }
// `;

// const OrdersReport = () => {
//   const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
//   const [skin, setSkin] = useState(currentSkin);
//   const navigate = useNavigate();
//   const animatedComponents = makeAnimated();

//   const { userId } = useSelector((s) => s.login);
//   const { access } = useSelector((s) => s.login);
//   const { email } = useSelector((s) => s.login);
//   const [reportAccess, setReportAccess] = useState([]);

//   useEffect(() => {
//     if (Array.isArray(access)) {
//       setReportAccess(access.filter((p) => p?.startsWith("OrdersReport:")));
//     }
//   }, [access]);

//   const accessToken = localStorage.getItem("authToken");

//   /* ── State ── */
//   const [outletWiseData, setOutletWiseData] = useState([]);
//   const [allFilteredOrders, setAllFilteredOrders] = useState([]);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [selectedOutlet, setSelectedOutlet] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [viewDetailsModal, setViewDetailsModal] = useState(false);
//   const [searchText, setSearchText] = useState("");
//   const [subBtnLoading, setSubBtnLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [ordersGrandTotal, setOrdersGrandTotal] = useState(0);
//   const [ordersTotalTaxAmt, setOrdersTotalTaxAmt] = useState(0);
//   const [ordersTotalDiscountAmt, setOrdersTotalDiscountAmt] = useState(0);
//   const [ordersTotalTaxable, setOrdersTotalTaxable] = useState(0);
//   const [recordsPerPage, setRecordsPerPage] = useState(25);
//   const [clicked, setClicked] = useState(false);
//   const [orderType, setOrderType] = useState("");
//   const [orderStatus, setOrderStatus] = useState("");
//   const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
//   const [currentDate, setCurrentDate] = useState(null);
//   const [activeView, setActiveView] = useState("outlet-wise");
//   const [activeOutletTab, setActiveOutletTab] = useState("all");

//   // Cancel Order
//   const [cancelBtnLoading, setCancelBtnLoading] = useState(false);
//   const [openCancelOrderModal, setOpenCancelOrderModal] = useState(false);
//   const [cancelOrderData, setCancelOrderData] = useState({});
//   const [refundType, setRefundType] = useState("");
//   const [isStockRefund, setIsStockRefund] = useState(false);
//   const [reason, setReason] = useState("");
//   const [selectedOrderId, setSelectedOrderId] = useState("");
//   const [usersList, setUsersList] = useState([]);
//   const [selectedAdminUser, setSelectedAdminUser] = useState("");

//   const [tableLoading, setTableLoading] = useState(false);

//   const [ordersTotalCancelledAmt, setOrdersTotalCancelledAmt] = useState(0);
//   const [ordersTotalCancelledCount, setOrdersTotalCancelledCount] = useState(0);

//   // Dropdown open state
//   const [openDropdownId, setOpenDropdownId] = useState(null);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setOpenDropdownId(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   /* ── Dates ── */
//   useEffect(() => {
//     const now = new Date();
//     const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
//     setCurrentDate(d);
//   }, []);
//   useEffect(() => {
//     if (currentDate) { setStartDate(currentDate); setEndDate(currentDate); }
//   }, [currentDate]);
//   useEffect(() => {
//     if (clicked && startDate && endDate) {
//       getOrderData(startDate, endDate, selectedOutlet?.map(o => o.value) || [], 1, recordsPerPage, searchText, orderType, orderStatus);
//     }
//   }, [recordsPerPage]);

//   useEffect(() => { getAdminUsersList(); }, []);

//   /* ── Helpers ── */
//   const getItemTotal = (item) => {
//     const base = item.rate;
//     const addons = item?.addons?.reduce((s, a) => s + a.price, 0) || 0;
//     return (base + addons) * item.quantity;
//   };

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//     getOrderData(startDate, endDate, selectedOutlet?.map(o => o.value) || [], page, recordsPerPage, searchText, orderType, orderStatus);
//   };

//   const handleSubmit = async () => {
//     setSubBtnLoading(true);
//     setClicked(true);
//     setCurrentPage(1);
//     await getOrderData(startDate, endDate, selectedOutlet?.map(o => o.value) || [], 1, recordsPerPage, searchText, orderType, orderStatus);
//     setSubBtnLoading(false);
//   };

//   const handleDownloadExcel = async () => {
//     setDownloadBtnLoading(true);
//     await getOrderData(startDate, endDate, selectedOutlet?.map(o => o.value) || [], currentPage, recordsPerPage, searchText, orderType, orderStatus, true);
//     setDownloadBtnLoading(false);
//   };

//   const getOrderData = async (start, end, outletIds, page, limit, search, orderT, orderS, download) => {
//     try {
//       setLoading(true);
//       setTableLoading(true);   // ← add this
//       const headers = { Authorization: `Bearer ${accessToken}` };
//       const params = {};
//       // if (start) params.startDate = start.toISOString().split("T")[0];
//       if (start) {
//         const year = start.getFullYear();
//         const month = String(start.getMonth() + 1).padStart(2, "0");
//         const day = String(start.getDate()).padStart(2, "0");

//         params.startDate = `${year}-${month}-${day}`;
//       }
//       // if (end) params.endDate = end.toISOString().split("T")[0];
//       if (end) {
//         const year = end.getFullYear();
//         const month = String(end.getMonth() + 1).padStart(2, "0");
//         const day = String(end.getDate()).padStart(2, "0");

//         params.endDate = `${year}-${month}-${day}`;
//       }
//       if (page) params.page = String(page);
//       if (limit) params.limit = String(limit);
//       if (search && search !== "") params.search = search;
//       if (orderT) params.orderType = orderT;
//       if (orderS) params.orderStatus = orderS;
//       if (download) params.isDownload = String(download);

//       const response = await axios({
//         method: "POST",
//         url: "order/getOrdersForAdmin/new",
//         params,
//         data: { outletIds },
//         headers: { ...headers, "Content-Type": "application/json" },
//         responseType: download ? "blob" : "json",
//       });

//       if (download) {
//         const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//         const link = document.createElement("a");
//         link.href = window.URL.createObjectURL(blob);
//         const outletLabel = selectedOutlet?.map(o => o.label).join("_") || "All Outlets";
//         link.download = `${outletLabel} Orders Report (${end?.toISOString().split("T")[0] || "report"}).xlsx`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(link.href);
//         toast.success("Excel downloaded successfully!", { position: "top-right", autoClose: 3000, theme: "light" });
//       } else {
//         const responseData = response?.data?.data?.finalOrderData ? response?.data?.data : [];
//         console.log("Reponse of The Api :", responseData);

//         if (responseData.length === 0) {
//           console.log("Hello");

//           toast.error("No data found for the selected criteria.", { position: "top-right", autoClose: 3000, theme: "light" });
//           setOutletWiseData([]); setAllFilteredOrders([]);
//           return;
//         }

//         if (responseData?.title === "Success") {
//           const finalOrderData = responseData?.finalOrderData || [];
//           if (finalOrderData.length > 0) {
//             const outletDataArray = finalOrderData.map((outletData, index) => {
//               const outletName = outletData?.outlet?.name || `Outlet ${index + 1}`;
//               // const formattedOrders = (outletData.orders || []).map(order => ({
//               //   order,
//               //   orderStatusLogs: order.orderStatusLogs || [],
//               //   orderItems: order.orderItems || [],
//               // }));
//               const formattedOrders = (outletData.orders || [])
//                 .map(order => ({
//                   order,
//                   orderStatusLogs: order.orderStatusLogs || [],
//                   orderItems: order.orderItems || [],
//                 }))
//                 .sort((a, b) => {
//                   const dateA = new Date(a?.order?.createdAt);
//                   const dateB = new Date(b?.order?.createdAt);
//                   if (dateB - dateA !== 0) return dateB - dateA;
//                   const seqA = `${a?.order?.order_sequence || ""}${a?.order?.order_no || ""}`;
//                   const seqB = `${b?.order?.order_sequence || ""}${b?.order?.order_no || ""}`;
//                   return seqB.localeCompare(seqA, undefined, { numeric: true });
//                 });
//               return {
//                 outletName,
//                 outletId: outletData?.outlet?._id || "",
//                 orders: formattedOrders,
//                 totalOrders: outletData.totalOrdersCount || 0,
//                 grandTotal: outletData.ordersGrandTotal || 0,
//                 totalDiscount: outletData.ordersTotalDiscount || 0,
//                 totalTaxAmount: outletData.ordersTotalTaxAmount || 0,
//                 totalTaxable: outletData.ordersTotalTaxable || 0,
//                 paginationData: outletData.paginationData || { currentPage: 1, totalPages: 1 },
//                 cancelledOrdersCount: outletData.cancelledOrdersCount || 0,
//                 cancelledOrdersRevenue: outletData.cancelledOrdersRevenue || 0,
//               };
//             });

//             // setOutletWiseData(outletDataArray);

//             // After building outletDataArray from finalOrderData...
//             const returnedOutletIds = new Set(outletDataArray.map(o => o.outletId));

//             const emptyOutlets = (selectedOutlet || [])
//               .filter(o => !returnedOutletIds.has(o.value))
//               .map(o => ({
//                 outletName: o.label,
//                 outletId: o.value,
//                 orders: [],
//                 totalOrders: 0,
//                 grandTotal: 0,
//                 totalDiscount: 0,
//                 totalTaxAmount: 0,
//                 totalTaxable: 0,
//                 cancelledOrdersCount: 0,
//                 cancelledOrdersRevenue: 0,
//                 paginationData: { currentPage: 1, totalPages: 1 },
//               }));

//             const mergedOutletData = [...outletDataArray, ...emptyOutlets];
//             setOutletWiseData(mergedOutletData);



//             // let allOrders = [], disc = 0, tax = 0, taxable = 0, grand = 0, count = 0, maxPages = 0;
//             // outletDataArray.forEach(o => {
//             //   allOrders = [...allOrders, ...o.orders];
//             //   disc += o.totalDiscount; tax += o.totalTaxAmount;
//             //   taxable += o.totalTaxable; grand += o.grandTotal;
//             //   count += o.totalOrders;
//             //   maxPages = Math.max(maxPages, o.paginationData.totalPages || 0);
//             // });

//             let allOrders = [], disc = 0, tax = 0, taxable = 0, grand = 0, count = 0, maxPages = 0, cancelledAmt = 0, cancelledCount = 0;
//             mergedOutletData.forEach(o => {
//               allOrders = [...allOrders, ...o.orders];
//               disc += o.totalDiscount; tax += o.totalTaxAmount;
//               taxable += o.totalTaxable; grand += o.grandTotal;
//               count += o.totalOrders;
//               cancelledAmt += o.cancelledOrdersRevenue;
//               cancelledCount += o.cancelledOrdersCount;
//               maxPages = Math.max(maxPages, o.paginationData.totalPages || 0);
//             });


//             // setAllFilteredOrders(allOrders);
//             const sortedOrders = [...allOrders].sort((a, b) => {
//               const dateA = new Date(a?.order?.createdAt);
//               const dateB = new Date(b?.order?.createdAt);

//               // Sort by date descending first
//               if (dateB - dateA !== 0) return dateB - dateA;

//               // Then by order number descending within same date
//               const seqA = `${a?.order?.order_sequence || ""}${a?.order?.order_no || ""}`;
//               const seqB = `${b?.order?.order_sequence || ""}${b?.order?.order_no || ""}`;
//               return seqB.localeCompare(seqA, undefined, { numeric: true });
//             });
//             setAllFilteredOrders(sortedOrders);

//             setTotalPages(maxPages || 1);
//             setTotalRecords(count);
//             setOrdersGrandTotal(grand);
//             setOrdersTotalDiscountAmt(disc);
//             setOrdersTotalTaxAmt(tax);
//             setOrdersTotalTaxable(taxable);
//             setOrdersTotalCancelledAmt(cancelledAmt);
//             setOrdersTotalCancelledCount(cancelledCount);
//             setActiveOutletTab("all");
//             toast.success("Report fetched successfully", { position: "top-right", autoClose: 2500, theme: "light" });
//           } else {
//             toast.info("No records found.", { position: "top-right", autoClose: 3000, theme: "light" });
//             setOutletWiseData([]); setAllFilteredOrders([]);
//           }
//         }
//       }
//     } catch (error) {
//       setOutletWiseData([]); setAllFilteredOrders([]);
//       console.log("Error Log :", error);

//       if (error?.response) {
//         const s = error.response.status;
//         console.log("s error", s);

//         const msg = s === 406 ? (error.response.data?.error?.message || error.response.data?.error)
//           : s === 412 ? error.response.data?.data?.message || error.response.data?.data?.title
//             : s === 500 ? error.response.data?.error
//               : "Something went wrong. Please try again.";
//         toast.error(msg, { position: "top-right", autoClose: 3000, theme: "light" });
//       }
//     } finally {
//       setLoading(false); 
//       setSubBtnLoading(false); 
//       setDownloadBtnLoading(false);
//       setTableLoading(false);   // ← add this
//     }
//   };

//   const getAdminUsersList = async () => {
//     try {
//       const headers = { Authorization: `Bearer ${accessToken}` };
//       const response = await axios.get("admin-user-management", { headers });
//       if (response?.data?.status === true) {
//         const list = response.data.data.dbResponse.map((item, i) => ({ ...item, serialNumber: i + 1 }));
//         setUsersList(list);
//       }
//     } catch (e) { console.log("Error fetching admin users:", e); }
//   };

//   const adminUserOptions = usersList.map(u => ({ value: u._id, label: u.name }));

//   const viewOrderDetails = (order) => {
//     console.log("Log of Order Details :", order);

//     setSelectedOrder(order);
//     setViewDetailsModal(true);
//   };
//   const closeModal = () => { setViewDetailsModal(false); setSelectedOrder(null); };

//   const handleOpenCancelOrderModal = (orderData) => {
//     setOpenCancelOrderModal(true);
//     setCancelOrderData(orderData);
//     setSelectedOrderId(orderData?.order?._id);
//   };
//   const handleCloseCancelOrderModal = () => {
//     setOpenCancelOrderModal(false);
//     setRefundType(""); setIsStockRefund(false);
//     setSelectedOrderId(""); setReason(""); setSelectedAdminUser("");
//   };

//   const handleCancelNormalOrder = async (e) => {
//     e.preventDefault(); setCancelBtnLoading(true);
//     try {
//       const headers = { Authorization: `Bearer ${accessToken}` };
//       const reqBody = { refundType, reason, isStockRefund, _id: selectedOrderId, approval: selectedAdminUser, userId };
//       const response = await axios.put("order/cancel/admin/new", reqBody, { headers });
//       await getOrderData(startDate, endDate, selectedOutlet?.map(o => o.value) || [], currentPage, recordsPerPage, searchText, orderType, orderStatus);
//       toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
//       handleCloseCancelOrderModal();
//     } catch (error) {
//       const s = error.response?.status;
//       const msg = s === 406 ? (error.response.data?.error?.message || error.response.data?.error)
//         : s === 403 ? (error.response.data?.data?.message || error.response.data?.error)
//           : s === 412 ? error.response.data?.data?.message
//             : s === 500 ? error.response.data?.error : "";
//       toast.error(msg, { position: "top-right", autoClose: 3000, theme: "light" });
//     } finally { setCancelBtnLoading(false); }
//   };

//   const handleCancelSubsOrder = async (e) => {
//     e.preventDefault(); setCancelBtnLoading(true);
//     try {
//       const headers = { Authorization: `Bearer ${accessToken}` };
//       const reqBody = { refundType, reason, approval: selectedAdminUser, isStockRefund, _id: selectedOrderId };
//       const response = await axios.put("order/cancelOrderAdmin", reqBody, { headers });
//       await getOrderData(startDate, endDate, selectedOutlet?.map(o => o.value) || [], currentPage, recordsPerPage, searchText, orderType, orderStatus);
//       toast.success(response?.data?.data?.message, { position: "top-right", autoClose: 3000, theme: "colored" });
//       handleCloseCancelOrderModal();
//     } catch (error) {
//       const s = error.response?.status;
//       const msg = s === 406 ? (error.response.data?.error?.message || error.response.data?.error)
//         : s === 412 ? error.response.data?.data?.message
//           : s === 500 ? error.response.data?.error : "";
//       toast.error(msg, { position: "top-right", autoClose: 3000, theme: "colored" });
//     } finally { setCancelBtnLoading(false); }
//   };

//   /* ── Badge helpers ── */
//   const getStatusClass = (status) => {
//     switch (status) {
//       case "COMPLETED": return "completed";
//       case "DELIVERED": return "delivered";
//       case "CONFIRMED": return "confirmed";
//       case "READY-TO-PICK": return "ready";
//       case "CANCELLED": return "cancelled";
//       default: return "default";
//     }
//   };
//   const getStatusBadgeColor = (status) => {
//     switch (status) {
//       case "COMPLETED": return "success";
//       case "DELIVERED": return "primary";
//       case "CONFIRMED": return "secondary";
//       case "READY-TO-PICK": return "warning";
//       case "CANCELLED": return "danger";
//       default: return "dark";
//     }
//   };

//   /* ── Pagination renderer ── */
//   const renderPaginationItems = () => {
//     if (totalPages <= 1) return null;
//     const items = [];
//     if (totalPages > 15) {
//       if (currentPage > 3) items.push(<Pagination.Item key="1" onClick={() => handlePageChange(1)}>1</Pagination.Item>);
//       if (currentPage > 4) items.push(<Pagination.Ellipsis key="el1" />);
//       for (let i = 0; i < 5; i++) {
//         const p = currentPage > 3 ? currentPage - 2 + i : i + 1;
//         if (p <= totalPages) items.push(<Pagination.Item key={p} active={p === currentPage} onClick={() => handlePageChange(p)}>{p}</Pagination.Item>);
//       }
//       if (currentPage < totalPages - 3) items.push(<Pagination.Ellipsis key="el2" />);
//       if (currentPage < totalPages - 2) items.push(<Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>);
//     } else {
//       for (let i = 1; i <= totalPages; i++) {
//         items.push(<Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>{i}</Pagination.Item>);
//       }
//     }
//     return items;
//   };

//   /* ── Current orders ── */
//   const getCurrentOrders = () => {
//     if (activeView === "combined") return allFilteredOrders;
//     if (activeOutletTab === "all") return allFilteredOrders;
//     return outletWiseData.find(o => o.outletName === activeOutletTab)?.orders || [];
//   };

//   const getCurrentOutletTotals = () => {
//     if (activeView === "combined" || activeOutletTab === "all") return null;
//     return outletWiseData.find(o => o.outletName === activeOutletTab) || null;
//   };

//   const getOrderUserBadge = (order) => {
//     if (order?.subscriptionId) {
//       return (
//         <span style={{
//           display: "inline-flex", alignItems: "center", gap: 4,
//           padding: "2px 8px", borderRadius: 20,
//           fontSize: 10, fontWeight: 700, letterSpacing: ".2px",
//           background: "#f0fdf4", color: "#15803d",
//           border: "1px solid #bbf7d0", marginTop: 3
//         }}>
//            Subscription
//         </span>
//       );
//     }
//     if (order?.kioskUser) {
//       return (
//         <span style={{
//           display: "inline-flex", alignItems: "center", gap: 4,
//           padding: "2px 8px", borderRadius: 20,
//           fontSize: 10, fontWeight: 700, letterSpacing: ".2px",
//           background: "#eff6ff", color: "#1d4ed8",
//           border: "1px solid #bfdbfe", marginTop: 3
//         }}>
//            Kiosk Order
//         </span>
//       );
//     }
//     if (order?.outletUser) {
//       return (
//         <span className="w-100" style={{
//           display: "inline-flex", alignItems: "center", gap: 4,
//           padding: "2px 8px", borderRadius: 20,
//           fontSize: 10, fontWeight: 700, letterSpacing: ".2px",
//           background: "#fdf4ff", color: "#7e22ce",
//           border: "1px solid #e9d5ff", marginTop: 3
//         }}>
//            Complimentary
//         </span>
//       );
//     }
//     return null;
//   };

//   /* ── Print invoice ── */
//   const handlePrintInvoice = (order) => {
//     const win = window.open("", "", "width=820,height=700");
//     const arrivalBadge = (() => {
//       const status = order?.order?.orderArrivalStatus;
//       if (status === "DELAYED") return `<span style="background:rgba(220,53,69,0.1);color:#dc3545;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:600;">⏱ Delayed (+${order?.order?.delayedArrival} min)</span>`;
//       if (status === "EARLY") return `<span style="background:rgba(25,135,84,0.1);color:#198754;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:600;">⚡ Early (-${order?.order?.earlyArrival} min)</span>`;
//       return `<span style="background:rgba(13,110,253,0.1);color:#0d6efd;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:600;">✓ On Time</span>`;
//     })();
//     const itemsRows = order.orderItems.map(item => `
//       <tr>
//         <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;">
//           <div style="font-weight:600;font-size:13px;">${item.product?.name || "Product"}</div>
//           ${item?.addons?.length > 0 ? `<div>${item.addons.map(a => `<span style="font-size:11px;color:#666;display:block;padding-left:10px;">+ ${a.selectedValue} (₹${a.price?.toFixed(2)})</span>`).join("")}</div>` : ""}
//         </td>
//         <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:center;">${item.quantity}</td>
//         <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:right;">₹${item.rate?.toFixed(2)}</td>
//         <td style="padding:10px 12px;border-bottom:1px solid #f0f0f0;text-align:right;font-weight:600;">₹${(item.rate * item.quantity + (item?.addons?.reduce((s, a) => s + a.price, 0) || 0) * item.quantity).toFixed(2)}</td>
//       </tr>`).join("");
//     const outletName = order?.orderStatusLogs?.[0]?.outlet?.name || "XPANSE CAFE";
//     const outletAddress = order?.orderStatusLogs?.[0]?.outlet?.address || "";
//     const outletGstin = order?.orderStatusLogs?.[0]?.outlet?.gstin || "N/A";
//     const outletPhone = order?.orderStatusLogs?.[0]?.outlet?.phone || "N/A";
//     win.document.write(`<!DOCTYPE html><html><head><title>Invoice #${order.order.order_sequence}${order.order.order_no}</title>
//       <style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:sans-serif;background:#f5f5f0}
//       .page{max-width:720px;margin:30px auto;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,.1)}
//       .header{background:linear-gradient(135deg,#1a1a2e,#0f3460);padding:36px 40px 28px}
//       .store-name{font-size:26px;font-weight:700;color:#fff}
//       .store-meta{font-size:11.5px;color:rgba(255,255,255,.65);margin-top:14px;line-height:1.7}
//       .invoice-label{display:inline-block;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.2);color:#fff;font-size:11px;font-weight:600;letter-spacing:2px;text-transform:uppercase;padding:5px 14px;border-radius:20px;margin-top:16px}
//       .meta-strip{display:grid;grid-template-columns:repeat(3,1fr);border-bottom:1px solid #f0f0f0}
//       .meta-cell{padding:18px 22px;border-right:1px solid #f0f0f0}.meta-cell:last-child{border-right:none}
//       .meta-label{font-size:10px;font-weight:600;color:#999;text-transform:uppercase;letter-spacing:1px;margin-bottom:5px}
//       .meta-value{font-size:13px;font-weight:600}
//       table{width:100%;border-collapse:collapse}thead tr{background:#f8f8f6}thead th{padding:10px 12px;font-size:10px;font-weight:700;color:#888;text-transform:uppercase}
//       .items-section{padding:24px}
//       .total-row{display:flex;justify-content:space-between;padding:7px 12px;font-size:13px;color:#555}
//       .grand-total{background:linear-gradient(135deg,#1a1a2e,#0f3460);margin:16px 24px 24px;border-radius:12px;padding:18px 20px;display:flex;justify-content:space-between;align-items:center}
//       .grand-total span:first-child{font-size:13px;color:rgba(255,255,255,.7)}.grand-total span:last-child{font-size:22px;font-weight:700;color:#fff}
//       .footer{background:#f8f8f6;padding:18px 24px;display:flex;justify-content:space-between;border-top:1px solid #eee}
//       @media print{body{background:#fff}.page{box-shadow:none;margin:0;border-radius:0}}</style>
//       </head><body onload="window.print();window.close()">
//       <div class="page">
//         <div class="header"><div class="store-name">${outletName}</div><div class="store-meta">${outletAddress}<br/>GSTIN: ${outletGstin} | Tel: ${outletPhone}</div><div class="invoice-label">Tax Invoice</div></div>
//         <div class="meta-strip">
//           <div class="meta-cell"><div class="meta-label">Invoice No</div><div class="meta-value">#${order?.order?.order_sequence}${order?.order?.order_no}</div></div>
//           <div class="meta-cell"><div class="meta-label">Date & Time</div><div class="meta-value">${new Date(order?.order?.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</div><div style="font-size:11px;color:#888">${new Date(order?.order?.createdAt).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}</div></div>
//           <div class="meta-cell"><div class="meta-label">Status</div><span>${order?.order?.orderStatus}</span></div>
//         </div>
//         <div style="display:grid;grid-template-columns:1fr 1fr;border-bottom:1px solid #f0f0f0">
//           // AFTER
// <div style="padding:20px 24px;border-right:1px solid #f0f0f0">
//   <h4 style="font-size:10px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:10px">Bill To</h4>
//   <p>
//     <strong>${order?.order?.user?.name ||
//       order?.order?.outletUser?.name ||
//       order?.order?.kioskUser?.name ||
//       "Walk-in Customer"
//       }</strong><br/>
//     ${order?.order?.user?.mobile ||
//       order?.order?.outletUser?.mobile ||
//       order?.order?.kioskUser?.mobile ||
//       ""
//       }
//   </p>
//   ${order?.order?.subscriptionId
//         ? `<span style="display:inline-block;margin-top:8px;padding:2px 10px;border-radius:20px;font-size:10px;font-weight:700;background:#f0fdf4;color:#15803d;border:1px solid #bbf7d0;">🔄 Subscription</span>`
//         : order?.order?.kioskUser
//           ? `<span style="display:inline-block;margin-top:8px;padding:2px 10px;border-radius:20px;font-size:10px;font-weight:700;background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;">🖥️ Kiosk Order</span>`
//           : order?.order?.outletUser
//             ? `<span style="display:inline-block;margin-top:8px;padding:2px 10px;border-radius:20px;font-size:10px;font-weight:700;background:#fdf4ff;color:#7e22ce;border:1px solid #e9d5ff;">🎁 Complimentary</span>`
//             : ""
//       }
// </div>
//           <div style="padding:20px 24px"><h4 style="font-size:10px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:10px">Order Info</h4><p><strong>Type:</strong> ${order?.order?.ordersType || order?.order?.paymentMode}<br/><strong>Payment:</strong> ${order?.order?.paymentStatus}</p></div>
//         </div>
//         <div class="items-section">
//           <table><thead><tr><th>Description</th><th style="text-align:center">Qty</th><th style="text-align:right">Price</th><th style="text-align:right">Amount</th></tr></thead><tbody>${itemsRows}</tbody></table>
//           <div style="border-top:2px solid #f0f0f0;margin-top:4px">
//             <div class="total-row"><span>Subtotal</span><span>₹${order?.order?.totalTaxable?.toFixed(2)}</span></div>
//             <div class="total-row" style="color:#dc3545"><span>Discount</span><span>− ₹${order?.order?.totalDiscount?.toFixed(2)}</span></div>
//             <div class="total-row" style="color:#f59e0b"><span>Tax</span><span>+ ₹${order?.order?.totalTaxAmount?.toFixed(2)}</span></div>
//           </div>
//         </div>
//         <div class="grand-total"><span>GRAND TOTAL</span><span>₹${order?.order?.grandTotal?.toFixed(2)}</span></div>
//         <div style="padding:10px 24px 4px;display:flex;align-items:center;gap:10px;font-size:12px;color:#555"><span>Arrival:</span>${arrivalBadge}</div>
//         <div style="text-align:center;padding:14px;font-size:12px;color:#888">Thank you for choosing ${outletName}! 🙏</div>
//         <div class="footer"><div>Terms & Conditions Apply<br/>Computer generated invoice</div><div>Powered by Xpanse POS</div></div>
//       </div></body></html>`);
//     win.document.close();
//   };

//   /* ── Orders table renderer ── */
//   const renderOrdersTable = (orders, showOutletCol = false, outletTotals = null) => {
//     return (
//       <div className="or-table-wrap">
//         <table className="or-table">
//           <thead>
//             <tr>
//               <th style={{ width: 44 }}>Sr.No</th>
//               <th style={{ width: 130 }}>Date / Time</th>
//               <th style={{ width: 120 }}>Order No</th>
//               {showOutletCol && <th style={{ width: 140 }}>Outlet</th>}
//               <th style={{ width: 150 }}>Customer</th>
//               <th style={{ width: 120 }}>Status</th>
//               <th style={{ width: 120, textAlign: "center" }}>Arrival</th>
//               <th style={{ width: 100, textAlign: "right" }}>Taxable</th>
//               <th style={{ width: 80, textAlign: "right" }}>Tax</th>
//               <th style={{ width: 90, textAlign: "right" }}>Discount</th>
//               <th style={{ width: 100, textAlign: "right" }}>Total</th>
//               <th style={{ width: 90, textAlign: "center" }}>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {orders.length > 0 ? (
//               <>
//                 {orders.map((orderData, idx) => (
//                   <tr key={orderData?.order?._id || idx}>
//                     <td className="row-clickable" style={{ color: "#9ca3af", fontSize: 12 }} onClick={() => viewOrderDetails(orderData)}>{idx + 1}</td>
//                     <td className="row-clickable" onClick={() => viewOrderDetails(orderData)}>
//                       <div style={{ fontSize: 12.5, fontWeight: 500 }}>
//                         {new Date(orderData?.order?.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
//                       </div>
//                       <div style={{ fontSize: 11.5, color: "#9ca3af" }}>
//                         {new Date(orderData?.order?.createdAt).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}
//                       </div>
//                     </td>
//                     <td className="row-clickable" onClick={() => viewOrderDetails(orderData)}>
//                       <span className="or-orderno">{orderData?.order?.order_sequence}{orderData?.order?.order_no}</span>
//                     </td>
//                     {showOutletCol && (
//                       <td className="row-clickable" onClick={() => viewOrderDetails(orderData)}>
//                         <span style={{ fontSize: 12, color: "#6b7280" }}>{orderData?.order?.outlet?.name || "N/A"}</span>
//                       </td>
//                     )}
//                     <td className="row-clickable" onClick={() => viewOrderDetails(orderData)}>
//                       <div style={{ fontWeight: 600, fontSize: 13 }}>{orderData?.order?.user?.name || orderData?.order?.outletUser?.name || orderData?.order?.kioskUser?.name}</div>
//                       <div style={{ fontSize: 11.5, color: "#2563eb" }}>{orderData?.order?.user?.mobile || orderData?.order?.outletUser?.mobile || orderData?.order?.kioskUser?.mobile}</div>
//                       {getOrderUserBadge(orderData?.order)}
//                     </td>
//                     <td className="row-clickable" onClick={() => viewOrderDetails(orderData)}>
//                       <span className={`or-badge ${getStatusClass(orderData?.order?.orderStatus)}`}>
//                         <span className="or-badge-dot" style={{ background: "currentColor" }} />
//                         {orderData?.order?.orderStatus}
//                       </span>
//                     </td>
//                     <td className="row-clickable" style={{ textAlign: "center" }} onClick={() => viewOrderDetails(orderData)}>
//                       {orderData?.order?.orderArrivalStatus === "DELAYED" ? (
//                         <span className="or-arrival delayed">⏱ Delayed By {orderData?.order?.delayedArrival}m</span>
//                       ) : orderData?.order?.orderArrivalStatus === "EARLY" ? (
//                         <span className="or-arrival early">⚡ Early By {orderData?.order?.earlyArrival}m</span>
//                       ) : (
//                         <span className="or-arrival ontime">✓ On Time</span>
//                       )}
//                     </td>

//                     <td className="row-clickable" style={{ textAlign: "right" }} onClick={() => viewOrderDetails(orderData)}>
//                       <span className="or-amount green">₹{orderData?.order?.totalTaxable?.toFixed(2)}</span>
//                     </td>
//                     <td className="row-clickable" style={{ textAlign: "right" }} onClick={() => viewOrderDetails(orderData)}>
//                       <span className="or-amount amber">₹{orderData?.order?.totalTaxAmount?.toFixed(2)}</span>
//                     </td>
//                     <td className="row-clickable" style={{ textAlign: "right" }} onClick={() => viewOrderDetails(orderData)}>
//                       <span className="or-amount red">₹{orderData?.order?.totalDiscount?.toFixed(2)}</span>
//                     </td>
//                     <td className="row-clickable" style={{ textAlign: "right" }} onClick={() => viewOrderDetails(orderData)}>
//                       <span className="or-amount blue">₹{orderData?.order?.grandTotal?.toFixed(2)}</span>
//                     </td>
//                     <td style={{ textAlign: "center" }} ref={openDropdownId === (orderData?.order?._id || idx) ? dropdownRef : null}>
//                       <div className="or-dropdown" style={{ display: "inline-block", position: "relative" }}>
//                         <button
//                           className="or-action-btn"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             setOpenDropdownId(prev => prev === (orderData?.order?._id || idx) ? null : (orderData?.order?._id || idx));
//                           }}
//                         >
//                           Actions <ChevronDown size={11} />
//                         </button>
//                         {openDropdownId === (orderData?.order?._id || idx) && (
//                           <div className="or-dropdown-menu" onClick={e => e.stopPropagation()}>
//                             <button className="or-dropdown-item" onClick={() => { viewOrderDetails(orderData); setOpenDropdownId(null); }}>
//                               <Eye size={14} style={{ color: "#059669" }} /> View Details
//                             </button>
//                             {((reportAccess?.includes("OrdersReport:update") || email === "contact@xpansecafe.com") &&
//                               orderData?.order?.orderStatus !== "CANCELLED" &&
//                               new Date(orderData?.order?.createdAt).toDateString() === currentDate?.toDateString() &&
//                               orderData?.order?.paymentMode !== "COMPLIMENTARY") && (
//                                 <button className="or-dropdown-item danger" onClick={() => { handleOpenCancelOrderModal(orderData); setOpenDropdownId(null); }}>
//                                   <XCircle size={14} /> Cancel Order
//                                 </button>
//                               )}
//                             <button className="or-dropdown-item" onClick={() => { handlePrintInvoice(orderData); setOpenDropdownId(null); }}>
//                               <Receipt size={14} style={{ color: "#2563eb" }} /> Print Invoice
//                             </button>
//                           </div>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//                 {outletTotals && (
//                   <tr className="totals-row">
//                     <td colSpan={showOutletCol ? 7 : 6} style={{ textAlign: "right" }}>Outlet Total</td>
//                     <td style={{ textAlign: "right" }}><span className="or-amount green">₹{outletTotals.totalTaxable?.toFixed(2)}</span></td>
//                     <td style={{ textAlign: "right" }}><span className="or-amount amber">₹{outletTotals.totalTaxAmount?.toFixed(2)}</span></td>
//                     <td style={{ textAlign: "right" }}><span className="or-amount red">₹{outletTotals.totalDiscount?.toFixed(2)}</span></td>
//                     <td style={{ textAlign: "right" }}><span className="or-amount blue">₹{outletTotals.grandTotal?.toFixed(2)}</span></td>
//                     <td />
//                   </tr>
//                 )}
//               </>
//             ) : (
//               <tr>
//                 <td colSpan={showOutletCol ? 12 : 11}>
//                   <div className="or-empty" style={{ padding: "40px 24px" }}>
//                     <div className="or-empty-icon">📋</div>
//                     <div className="or-empty-title">No orders found</div>
//                     <div className="or-empty-sub">Try adjusting your filters</div>
//                   </div>
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     );
//   };

//   const selectStyles = {
//     control: (p, s) => ({
//       ...p, borderRadius: 6, minWidth: 200,
//       borderColor: s.isFocused ? "#2563eb" : "#e2e6ea",
//       boxShadow: s.isFocused ? "0 0 0 3px rgba(37,99,235,.1)" : "none",
//       "&:hover": { borderColor: s.isFocused ? "#2563eb" : "#e2e6ea" },
//       fontFamily: "'Outfit', sans-serif", fontSize: 13.5,
//     }),
//     placeholder: (p) => ({ ...p, color: "#9ca3af" }),
//     option: (p, s) => ({
//       ...p, fontFamily: "'Outfit', sans-serif", fontSize: 13.5,
//       background: s.isSelected ? "#2563eb" : s.isFocused ? "#eff6ff" : "#fff",
//     }),
//   };

//   /* ── Render ── */
//   return (
//     <React.Fragment>
//       <style>{CSS}</style>
//       <Header onSkin={setSkin} />
//       <div className="or-root main main-app" style={{ background: "#f0f2f5", minHeight: "100vh", padding: "24px" }}>
//         <div className="or-card">
//           {/* ── Header ── */}
//           <div className="or-header">
//             <div className="or-header-title">
//               {/* <div className="icon-box">🛒</div> */}
//               <i className="bi bi-bag me-2"></i>
//               ORDERS REPORT
//             </div>
//             <button className="or-back-btn" onClick={() => navigate("/reports/all-reports")}>
//               <ArrowLeft size={14} /> Back to Reports
//             </button>
//           </div>

//           {/* ── Filters ── */}
//           <div className="or-filters">
//             <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr", gap: 16, marginBottom: 16, flexWrap: "wrap" }}>
//               <div>
//                 {/* <label className="or-filter-label">Outlets</label> */}
//                 <OutletSelect isMulti value={selectedOutlet} onChange={setSelectedOutlet} required />
//               </div>
//               <div>
//                 <label className="or-filter-label"><i className="bi bi-calendar me-1"></i> Start Date</label>
//                 <DatePicker
//                   selected={startDate}
//                   onChange={setStartDate}
//                   dateFormat="dd-MM-yyyy"
//                   placeholderText="Start Date"
//                   className="form-control"
//                   style={{ width: "100%", fontFamily: "'Outfit', sans-serif" }}
//                   selectsStart startDate={startDate} endDate={endDate}
//                 />
//               </div>
//               <div>
//                 <label className="or-filter-label"><i className="bi bi-calendar-event me-1"></i> End Date</label>
//                 <DatePicker
//                   selected={endDate}
//                   onChange={setEndDate}
//                   dateFormat="dd-MM-yyyy"
//                   placeholderText="End Date"
//                   className="form-control"
//                   selectsEnd startDate={startDate} endDate={endDate} minDate={startDate}
//                 />
//               </div>
//               <div>
//                 <label className="or-filter-label"><i className="bi bi-list-check me-1"></i> Order Status</label>
//                 <select
//                   value={orderStatus}
//                   onChange={e => setOrderStatus(e.target.value)}
//                   style={{ width: "100%", padding: "8px 10px", border: "1.5px solid #e2e6ea", borderRadius: 6, fontSize: 13.5, fontFamily: "'Outfit', sans-serif", outline: "none", background: "#fff" }}
//                 >
//                   <option value="">All Status</option>
//                   <option value="CONFIRMED">Confirmed</option>
//                   <option value="CANCELLED">Cancelled</option>
//                   <option value="COMPLETED">Completed</option>
//                   <option value="DELIVERED">Delivered</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="or-filter-label"><i className="bi bi-bag-check me-1"></i> Order Type</label>
//                 <select
//                   value={orderType}
//                   onChange={e => setOrderType(e.target.value)}
//                   style={{ width: "100%", padding: "8px 10px", border: "1.5px solid #e2e6ea", borderRadius: 6, fontSize: 13.5, fontFamily: "'Outfit', sans-serif", outline: "none", background: "#fff" }}
//                 >
//                   <option value="">All Types</option>
//                   <option value="APP">App / Website</option>
//                   <option value="KIOSK">Kiosk</option>
//                   <option value="SUBSCRIBED">Subscription</option>
//                   <option value="COMPLIMENTARY">Complimentary</option>
//                 </select>
//               </div>

//             </div>
//             <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
//               <div className="w-50">
//                 <button
//                   className="or-generate-btn"
//                   onClick={handleSubmit}
//                   disabled={subBtnLoading || !selectedOutlet || selectedOutlet.length === 0 || !startDate || !endDate}
//                 >
//                   {subBtnLoading ? <Spinner size="sm" animation="border" /> : <>Generate Report</>}
//                 </button>
//               </div>
//               <div className="d-flex align-items-center gap-2" style={{ flex: "1 1 auto", justifyContent: "flex-end" }}>
//                 <div className="or-search-wrap">
//                   <Search size={13} className="search-icon" />
//                   <input
//                     className="or-search-input"
//                     placeholder="Search by name, order no, mobile…"
//                     value={searchText}
//                     onChange={e => setSearchText(e.target.value)}
//                     onKeyPress={e => { if (e.key === "Enter") handleSubmit(); }}
//                   />
//                 </div>
//                 <button className="or-toolbar-btn" onClick={handleSubmit} disabled={subBtnLoading}>
//                   {/* {subBtnLoading ? <Spinner size="sm" animation="border" /> : <><ArrowClockwise size={13} /> Refresh</>} */}
//                   {subBtnLoading ? <Spinner size="sm" animation="border" /> : <><Search size={13} /> Search</>}
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* ── KPI Strip ── */}
//           {clicked && outletWiseData.length > 0 && (
//             <>
//               {/* <div className="or-kpi-strip">
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Outlets</div>
//                   <div className="or-kpi-value teal">{outletWiseData.length}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Orders</div>
//                   <div className="or-kpi-value ink">{totalRecords.toLocaleString()}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Taxable</div>
//                   <div className="or-kpi-value green">₹{ordersTotalTaxable?.toFixed(2)}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Tax</div>
//                   <div className="or-kpi-value amber">₹{ordersTotalTaxAmt?.toFixed(2)}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Discount</div>
//                   <div className="or-kpi-value red">₹{ordersTotalDiscountAmt?.toFixed(2)}</div>
//                 </div>
                
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Grand Total</div>
//                   <div className="or-kpi-value blue">₹{ordersGrandTotal?.toFixed(2)}</div>
//                 </div>
//               </div> */}
//               <div className="or-kpi-strip" style={{ gridTemplateColumns: "repeat(7, 1fr)" }}>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Outlets</div>
//                   <div className="or-kpi-value teal">{outletWiseData.length}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Orders</div>
//                   <div className="or-kpi-value ink">{totalRecords.toLocaleString()}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Taxable</div>
//                   <div className="or-kpi-value green">₹{ordersTotalTaxable?.toFixed(2)}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Tax</div>
//                   <div className="or-kpi-value amber">₹{ordersTotalTaxAmt?.toFixed(2)}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Discount</div>
//                   <div className="or-kpi-value red">₹{ordersTotalDiscountAmt?.toFixed(2)}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Cancelled ({ordersTotalCancelledCount})</div>
//                   <div className="or-kpi-value red">₹{ordersTotalCancelledAmt?.toFixed(2)}</div>
//                 </div>
//                 <div className="or-kpi-cell">
//                   <div className="or-kpi-label">Grand Total</div>
//                   <div className="or-kpi-value blue">₹{ordersGrandTotal?.toFixed(2)}</div>
//                 </div>
//               </div>

//               {/* ── Outlet cards ── */}
//               <div className="or-outlet-grid">
//                 {outletWiseData.map((outlet, idx) => (
//                   // <div
//                   //   key={idx}
//                   //   className={`or-outlet-card ${activeOutletTab === outlet.outletName && activeView === "outlet-wise" ? "active" : ""}`}
//                   //   onClick={() => { setActiveView("outlet-wise"); setActiveOutletTab(outlet.outletName); }}
//                   // >
//                   //   <div className="or-outlet-name">
//                   //     <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                   //       <Shop size={14} style={{ color: "#2563eb" }} />
//                   //       {outlet.outletName}
//                   //     </span>
//                   //     <span style={{ fontSize: 11, fontWeight: 700, background: "#2563eb", color: "#fff", padding: "2px 8px", borderRadius: 12 }}>
//                   //       {outlet.totalOrders}
//                   //     </span>
//                   //   </div>  
//                   //   <div className="or-outlet-stats">
//                   //     <div className="or-outlet-stat">
//                   //       <div className="or-outlet-stat-label">Taxable</div>
//                   //       <div className="or-outlet-stat-val" style={{ color: "#059669" }}>₹{outlet.totalTaxable?.toFixed(0)}</div>
//                   //     </div>
//                   //     <div className="or-outlet-stat">
//                   //       <div className="or-outlet-stat-label">Tax</div>
//                   //       <div className="or-outlet-stat-val" style={{ color: "#d97706" }}>₹{outlet.totalTaxAmount?.toFixed(0)}</div>
//                   //     </div>
//                   //     <div className="or-outlet-stat">
//                   //       <div className="or-outlet-stat-label">Disc.</div>
//                   //       <div className="or-outlet-stat-val" style={{ color: "#dc2626" }}>₹{outlet.totalDiscount?.toFixed(0)}</div>
//                   //     </div>
//                   //     <div className="or-outlet-stat">
//                   //       <div className="or-outlet-stat-label">Total</div>
//                   //       <div className="or-outlet-stat-val" style={{ color: "#2563eb" }}>₹{outlet.grandTotal?.toFixed(0)}</div>
//                   //     </div>
//                   //   </div>
//                   // </div>

//                   <div
//                     key={idx}
//                     className={`or-outlet-card ${activeOutletTab === outlet.outletName && activeView === "outlet-wise" ? "active" : ""}`}
//                     onClick={() => { setActiveView("outlet-wise"); setActiveOutletTab(outlet.outletName); }}
//                     style={outlet.totalOrders === 0 ? { opacity: 0.6 } : {}}
//                   >
//                     <div className="or-outlet-name">
//                       <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                         <Shop size={14} style={{ color: outlet.totalOrders === 0 ? "#9ca3af" : "#2563eb" }} />
//                         {outlet.outletName}
//                       </span>
//                       <span style={{
//                         fontSize: 11, fontWeight: 700,
//                         background: outlet.totalOrders === 0 ? "#e5e7eb" : "#2563eb",
//                         color: outlet.totalOrders === 0 ? "#6b7280" : "#fff",
//                         padding: "2px 8px", borderRadius: 12
//                       }}>
//                         {outlet.totalOrders}
//                       </span>
//                     </div>

//                     {outlet.totalOrders === 0 ? (
//                       <div style={{
//                         textAlign: "center", padding: "10px 0",
//                         fontSize: 12, color: "#9ca3af", fontStyle: "italic"
//                       }}>
//                         No orders for this date
//                       </div>
//                     ) : (
//                       <div className="or-outlet-stats">
//                         <div className="or-outlet-stat">
//                           <div className="or-outlet-stat-label">Taxable</div>
//                           <div className="or-outlet-stat-val" style={{ color: "#059669" }}>₹{outlet.totalTaxable?.toFixed(2)}</div>
//                         </div>
//                         <div className="or-outlet-stat">
//                           <div className="or-outlet-stat-label">Tax</div>
//                           <div className="or-outlet-stat-val" style={{ color: "#d97706" }}>₹{outlet.totalTaxAmount?.toFixed(2)}</div>
//                         </div>
//                         <div className="or-outlet-stat">
//                           <div className="or-outlet-stat-label">Disc.</div>
//                           <div className="or-outlet-stat-val" style={{ color: "#dc2626" }}>₹{outlet.totalDiscount?.toFixed(2)}</div>
//                         </div>
//                         <div className="or-outlet-stat">
//                           <div className="or-outlet-stat-label">Cancelled</div>
//                           <div className="or-outlet-stat-val" style={{ color: "#dc2626" }}>
//                             ₹{outlet.cancelledOrdersRevenue?.toFixed(2)}
//                             {outlet.cancelledOrdersCount > 0 && (
//                               <span style={{
//                                 fontSize: 9,
//                                 fontWeight: 700,
//                                 background: "#fee2e2",
//                                 color: "#dc2626",
//                                 borderRadius: 10,
//                                 padding: "1px 5px",
//                                 marginLeft: 4,
//                                 verticalAlign: "middle",
//                                 whiteSpace: "nowrap"
//                               }}>
//                                 ×{outlet.cancelledOrdersCount}
//                               </span>
//                             )}
//                           </div>
//                           {/* <div className="or-outlet-stat-val" style={{ color: "#dc2626" }}>₹{outlet.cancelledOrdersRevenue?.toFixed(0)}</div> */}
//                         </div>
//                         <div className="or-outlet-stat">
//                           <div className="or-outlet-stat-label">Total</div>
//                           <div className="or-outlet-stat-val" style={{ color: "#2563eb" }}>₹{outlet.grandTotal?.toFixed(2)}</div>
//                         </div>
//                       </div>
//                     )}
//                   </div>

//                 ))}
//               </div>

//               {/* ── Toolbar ── */}
//               <div className="or-toolbar" style={{ marginTop: 20 }}>
//                 <div className="or-toolbar-left">
//                   {/* <div className="or-search-wrap">
//                     <Search size={13} className="search-icon" />
//                     <input
//                       className="or-search-input"
//                       placeholder="Search by name, order no, mobile…"
//                       value={searchText}
//                       onChange={e => setSearchText(e.target.value)}
//                       onKeyPress={e => { if (e.key === "Enter") handleSubmit(); }}
//                     />
//                   </div>
//                   <button className="or-toolbar-btn" onClick={handleSubmit} disabled={subBtnLoading}>
//                     {subBtnLoading ? <Spinner size="sm" animation="border" /> : <><Search size={13} /> Search</>}
//                   </button> */}
//                 </div>
//                 <div className="or-toolbar-right">
//                   <div className="or-view-toggle">
//                     <button className={`or-view-btn ${activeView === "outlet-wise" ? "active" : ""}`} onClick={() => setActiveView("outlet-wise")}>
//                       <Shop size={13} /> Outlet-wise
//                     </button>
//                     <button className={`or-view-btn ${activeView === "combined" ? "active" : ""}`} onClick={() => { setActiveView("combined"); setActiveOutletTab("all"); }}>
//                       <TableIcon size={13} /> Combined
//                     </button>
//                   </div>
//                   <button
//                     className="or-toolbar-btn success"
//                     disabled={downloadBtnLoading || allFilteredOrders.length === 0}
//                     onClick={handleDownloadExcel}
//                   >
//                     <FileEarmarkSpreadsheet size={13} />
//                     {downloadBtnLoading ? <Spinner size="sm" animation="border" /> : "Export Excel"}
//                   </button>
//                 </div>
//               </div>

//               {/* ── Outlet tabs ── */}
//               {activeView === "outlet-wise" && (
//                 <div className="or-tab-strip mt-3">
//                   <button className={`or-tab ${activeOutletTab === "all" ? "active" : ""}`} onClick={() => setActiveOutletTab("all")}>
//                     All Outlets <span className="count">{totalRecords}</span>
//                   </button>
//                   {outletWiseData?.map((outlet, idx) => (
//                     <button key={idx} className={`or-tab ${activeOutletTab === outlet.outletName ? "active" : ""}`} onClick={() => setActiveOutletTab(outlet.outletName)}>
//                       {outlet.outletName} <span className="count">{outlet.totalOrders}</span>
//                     </button>
//                   ))}
//                 </div>
//               )}

//               {/* ── Table ── */}
//               {tableLoading ? (
//                 <div className="or-loading">
//                   <Spinner animation="border" variant="primary" />
//                   <span style={{ fontSize: 13.5 }}>Loading orders…</span>
//                 </div>
//               ) : (
//                 activeView === "combined"
//                   ? renderOrdersTable(allFilteredOrders, true)
//                   : activeOutletTab === "all"
//                     ? renderOrdersTable(allFilteredOrders, true)
//                     : renderOrdersTable(
//                       outletWiseData.find(o => o.outletName === activeOutletTab)?.orders || [],
//                       false,
//                       outletWiseData.find(o => o.outletName === activeOutletTab)
//                     )
//               )}

//               {/* ── Pagination ── */}
//               <div className="or-pagination">
//                 <div className="or-per-page">
//                   <span>Show</span>
//                   <select value={recordsPerPage} onChange={e => setRecordsPerPage(Number(e.target.value))}>
//                     <option value={25}>25</option>
//                     <option value={50}>50</option>
//                     <option value={100}>100</option>
//                     <option value={200}>200</option>
//                   </select>
//                   <span>entries</span>
//                 </div>
//                 <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//                   <span className="or-page-info">
//                     {allFilteredOrders.length > 0 ? `Showing ${allFilteredOrders.length} of ${totalRecords} orders` : ""}
//                   </span>
//                   {totalPages > 1 && (
//                     <Pagination className="mb-0" size="sm">
//                       <Pagination.Prev disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)} />
//                       {renderPaginationItems()}
//                       <Pagination.Next disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)} />
//                     </Pagination>
//                   )}
//                 </div>
//               </div>
//             </>
//           )}

//           {/* ── Empty state ── */}
//           {outletWiseData.length === 0 && !loading && (
//             <div className="or-empty">
//               <div className="or-empty-icon">📊</div>
//               <div className="or-empty-title">Select outlets &amp; date range</div>
//               <div className="or-empty-sub">Configure your filters above and click Generate Report to view orders.</div>
//             </div>
//           )}

//           {/* {subBtnLoading && (
//             <div className="or-loading">
//               <Spinner animation="border" variant="primary" />
//             </div>
//           )} */}

//           {/* ── Loading (initial) ── */}
//           {/* {loading && subBtnLoading && clicked && (
//             <div className="or-loading">
//               <Spinner animation="border" variant="primary" />
//               <span style={{ fontSize: 13.5 }}>Loading orders......…</span>
//             </div>
//           )} */}
//         </div>

//         {/* ── Cancel Order Modal ── */}
//         {openCancelOrderModal && (
//           <Modal show={openCancelOrderModal} onHide={handleCloseCancelOrderModal} size="lg" centered>
//             <Modal.Header closeButton className="or-modal-header">
//               <Modal.Title className="or-modal-title">
//                 <span style={{ color: "#dc2626" }}>⛔</span> Cancel Order
//               </Modal.Title>
//             </Modal.Header>
//             <Form onSubmit={cancelOrderData?.order?.subscriptionId ? handleCancelSubsOrder : handleCancelNormalOrder}>
//               <Modal.Body className="or-modal-body">
//                 <Row className="mb-3">
//                   <Col md={4}>
//                     <Form.Label className="or-filter-label">Refund Type <span className="text-danger">*</span></Form.Label>
//                     <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
//                       <Form.Check type="radio" label="Instant Refund" name="refundType" value="INSTANT" checked={refundType === "INSTANT"} onChange={e => setRefundType(e.target.value)} id="ref-instant" />
//                       <Form.Check type="radio" label="Normal Refund" name="refundType" value="NORMAL" checked={refundType === "NORMAL"} onChange={e => setRefundType(e.target.value)} id="ref-normal" />
//                     </div>
//                   </Col>
//                   <Col md={4}>
//                     <Form.Label className="or-filter-label">Stock Management <span className="text-danger">*</span></Form.Label>
//                     <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
//                       <Form.Check type="radio" label="Restore to inventory" name="stock-refund" checked={isStockRefund === true} onChange={() => setIsStockRefund(true)} id="stock-t" />
//                       <Form.Check type="radio" label="Do not restore" name="stock-refund" checked={isStockRefund === false} onChange={() => setIsStockRefund(false)} id="stock-f" />
//                     </div>
//                   </Col>
//                   <Col md={4}>
//                     <Form.Label className="or-filter-label">Approved By <span className="text-danger">*</span></Form.Label>
//                     <Select
//                       options={adminUserOptions}
//                       value={adminUserOptions.find(o => o.value === selectedAdminUser)}
//                       onChange={opt => setSelectedAdminUser(opt?.value || "")}
//                       isClearable
//                       styles={selectStyles}
//                       placeholder="Select approver…"
//                     />
//                   </Col>
//                 </Row>
//                 <Form.Group>
//                   <Form.Label className="or-filter-label">Reason <span className="text-danger">*</span></Form.Label>
//                   <Form.Control
//                     as="textarea" rows={3}
//                     value={reason}
//                     onChange={e => setReason(e.target.value)}
//                     placeholder="Please provide a reason for cancelling this order…"
//                     required
//                     style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13.5 }}
//                   />
//                 </Form.Group>
//               </Modal.Body>
//               <Modal.Footer>
//                 <Button variant="outline-secondary" onClick={handleCloseCancelOrderModal} disabled={cancelBtnLoading}>Dismiss</Button>
//                 <Button variant="danger" type="submit" disabled={cancelBtnLoading || !reason.trim() || !selectedAdminUser}>
//                   {cancelBtnLoading ? <Spinner size="sm" animation="border" /> : "Confirm Cancellation"}
//                 </Button>
//               </Modal.Footer>
//             </Form>
//           </Modal>
//         )}

//         {/* ── View Order Details Modal ── */}
//         <Modal show={viewDetailsModal} onHide={closeModal} size="lg" centered>
//           <Modal.Header closeButton className="or-modal-header">
//             <Modal.Title className="or-modal-title">Order Details</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="or-modal-body">
//             {selectedOrder ? (
//               <>
//                 <div className="or-detail-grid">
//                   <div className="or-detail-cell">
//                     <div className="or-modal-detail-label">Order No</div>
//                     <div className="or-modal-detail-val or-orderno">{selectedOrder?.order?.order_sequence}{selectedOrder?.order?.order_no}</div>
//                   </div>
//                   <div className="or-detail-cell">
//                     <div className="or-modal-detail-label">Order Type</div>
//                     <div className="or-modal-detail-val">{selectedOrder?.order?.ordersType}</div>
//                   </div>
//                   <div className="or-detail-cell">
//                     <div className="or-modal-detail-label">Outlet</div>
//                     <div className="or-modal-detail-val">{selectedOrder?.order?.outlet?.name || "N/A"}</div>
//                   </div>
//                   <div className="or-detail-cell">
//                     <div className="or-modal-detail-label">Customer</div>
//                     <div className="or-modal-detail-val">
//                       {selectedOrder?.order?.user?.name
//                         || selectedOrder?.order?.outletUser?.name
//                         || selectedOrder?.order?.kioskUser?.name
//                         || "N/A"}
//                     </div>
//                     {getOrderUserBadge(selectedOrder?.order)}
//                   </div>
//                   <div className="or-detail-cell">
//                     <div className="or-modal-detail-label">Mobile</div>
//                     <div className="or-modal-detail-val">{selectedOrder?.order?.user?.mobile || "N/A"}</div>
//                   </div>
//                   <div className="or-detail-cell">
//                     <div className="or-modal-detail-label">Date & Time</div>
//                     <div className="or-modal-detail-val" style={{ fontSize: 12.5 }}>
//                       {new Date(selectedOrder?.order?.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
//                       {" · "}
//                       {new Date(selectedOrder?.order?.createdAt).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}
//                     </div>
//                   </div>
//                   <div className="or-detail-cell">
//                     <div className="or-modal-detail-label">Status</div>
//                     <span className={`or-badge ${getStatusClass(selectedOrder?.order?.orderStatus)}`}>
//                       {selectedOrder?.order?.orderStatus}
//                     </span>
//                   </div>
//                   <div className="or-detail-cell">
//                     <div className="or-modal-detail-label">Payment</div>
//                     <div className="or-modal-detail-val" style={{ fontSize: 12.5 }}>
//                       {selectedOrder?.order?.paymentGatewayProvider}
//                       {selectedOrder?.order?.razorpayOrderId && <span style={{ color: "#9ca3af", fontSize: 11, display: "block" }}>{selectedOrder?.order?.razorpayOrderId}</span>}
//                     </div>
//                   </div>
//                   <div className="or-detail-cell">
//                     <div className="or-modal-detail-label">Payment Status</div>
//                     <Badge bg={selectedOrder.order?.paymentStatus === "PAID" ? "success" : "danger"}>
//                       {selectedOrder?.order?.paymentStatus}
//                     </Badge>
//                   </div>
//                 </div>

//                 <div style={{ marginBottom: 16 }}>
//                   <div className="or-modal-detail-label" style={{ marginBottom: 10 }}>Ordered Items</div>
//                   <Table striped bordered hover responsive size="sm" style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13 }}>
//                     <thead><tr><th>Product</th><th className="text-center">Qty</th><th className="text-end">Price</th><th className="text-end">Total</th></tr></thead>
//                     <tbody>
//                       {selectedOrder?.orderItems?.map((item) => (
//                         <tr key={item._id}>
//                           <td>
//                             {item?.product?.name || "Product"}
//                             {item?.addons?.length > 0 && (
//                               <ul className="mb-0" style={{ fontSize: 11.5, color: "#6b7280" }}>
//                                 {item.addons.map(a => <li key={a._id}>{a.selectedValue} (₹{a.price})</li>)}
//                               </ul>
//                             )}
//                           </td>
//                           <td className="text-center">{item?.quantity}</td>
//                           <td className="text-end">₹{item.rate?.toFixed(2)}</td>
//                           <td className="text-end fw-semibold">₹{getItemTotal(item).toFixed(2)}</td>
//                         </tr>
//                       ))}
//                       {selectedOrder?.order?.totalDiscount > 0 && (
//                         <tr><td colSpan={3} className="text-end">Discount</td><td className="text-end text-danger">− ₹{selectedOrder?.order?.totalDiscount?.toFixed(2)}</td></tr>
//                       )}
//                       {selectedOrder?.order?.totalTaxAmount > 0 && (
//                         <tr><td colSpan={3} className="text-end">Tax</td><td className="text-end">+ ₹{selectedOrder?.order?.totalTaxAmount?.toFixed(2)}</td></tr>
//                       )}
//                       <tr style={{ fontWeight: 700 }}>
//                         <td colSpan={3} className="text-end">Grand Total</td>
//                         <td className="text-end text-primary">₹{selectedOrder?.order?.grandTotal?.toFixed(2)}</td>
//                       </tr>
//                     </tbody>
//                   </Table>
//                 </div>

//                 <div>
//                   <div className="or-modal-detail-label" style={{ marginBottom: 10 }}>Status Log</div>
//                   <Table striped bordered hover responsive size="sm" style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13 }}>
//                     <thead><tr><th>Status</th><th>Time</th><th>Date</th></tr></thead>
//                     <tbody>
//                       {selectedOrder?.orderStatusLogs?.length > 0 ? selectedOrder.orderStatusLogs.map(log => (
//                         <tr key={log._id}>
//                           <td><Badge bg={getStatusBadgeColor(log.orderStatus)}>{log.orderStatus}</Badge></td>
//                           <td>{new Date(log.createdAt).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric", hour12: true })}</td>
//                           <td>{new Date(log.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</td>
//                         </tr>
//                       )) : <tr><td colSpan={3} className="text-center text-muted">No logs available</td></tr>}
//                     </tbody>
//                   </Table>
//                 </div>
//               </>
//             ) : <p>No order details available.</p>}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="outline-secondary" onClick={closeModal}>Close</Button>
//             {selectedOrder && (
//               <Button variant="primary" onClick={() => handlePrintInvoice(selectedOrder)}>
//                 <Receipt size={14} className="me-1" /> Print Invoice
//               </Button>
//             )}
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </React.Fragment>
//   );
// };

// export default OrdersReport;


